import { reactive, watchPostEffect } from "vue-demi";
var render$l = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { staticClass: "menu", attrs: { "width": "28", "height": "18", "viewBox": "0 0 28 18", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("line", { attrs: { "x1": "1.00049", "y1": "1", "x2": "27.0005", "y2": "1", "stroke": "black", "stroke-width": "2", "stroke-linecap": "round" } }), _c("line", { attrs: { "x1": "5.00049", "y1": "9", "x2": "27.0005", "y2": "9", "stroke": "black", "stroke-width": "2", "stroke-linecap": "round" } }), _c("line", { attrs: { "x1": "9.00049", "y1": "17", "x2": "27.0005", "y2": "17", "stroke": "black", "stroke-width": "2", "stroke-linecap": "round" } })]);
};
var staticRenderFns$l = [];
var index_vue_vue_type_style_index_0_scoped_true_lang$i = "";
function normalizeComponent(scriptExports, render2, staticRenderFns2, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render2) {
    options.render = render2;
    options.staticRenderFns = staticRenderFns2;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function(context) {
      context = context || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(
        this,
        (options.functional ? this.parent : this).$root.$options.shadowRoot
      );
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}
const __vue2_script$l = {
  name: "Menu"
};
const __cssModules$l = {};
var __component__$l = /* @__PURE__ */ normalizeComponent(
  __vue2_script$l,
  render$l,
  staticRenderFns$l,
  false,
  __vue2_injectStyles$l,
  "7aef3ad5",
  null,
  null
);
function __vue2_injectStyles$l(context) {
  for (let o in __cssModules$l) {
    this[o] = __cssModules$l[o];
  }
}
var Menu = /* @__PURE__ */ function() {
  return __component__$l.exports;
}();
var render$k = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { staticClass: "close", attrs: { "width": "28", "height": "26", "viewBox": "0 0 28 26", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("line", { attrs: { "x1": "2.4147", "y1": "1", "x2": "26.0005", "y2": "24.5858", "stroke": "black", "stroke-width": "2", "stroke-linecap": "round" } }), _c("line", { attrs: { "x1": "2.00049", "y1": "24.5858", "x2": "25.5863", "y2": "1", "stroke": "black", "stroke-width": "2", "stroke-linecap": "round" } })]);
};
var staticRenderFns$k = [];
var index_vue_vue_type_style_index_0_scoped_true_lang$h = "";
const __vue2_script$k = {
  name: "Close"
};
const __cssModules$k = {};
var __component__$k = /* @__PURE__ */ normalizeComponent(
  __vue2_script$k,
  render$k,
  staticRenderFns$k,
  false,
  __vue2_injectStyles$k,
  "2300ba9f",
  null,
  null
);
function __vue2_injectStyles$k(context) {
  for (let o in __cssModules$k) {
    this[o] = __cssModules$k[o];
  }
}
var Close = /* @__PURE__ */ function() {
  return __component__$k.exports;
}();
var render$j = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { class: ["arrow-down-circle", { "arrow-up-circle": _vm.forwadUp }], attrs: { "viewBox": "0 0 16 16", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { attrs: { "d": "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM5.20711 6.29289L8 9.08579L10.7929 6.29289C11.1834 5.90237 11.8166 5.90237 12.2071 6.29289C12.5976 6.68342 12.5976 7.31658 12.2071 7.70711L8.70711 11.2071C8.31658 11.5976 7.68342 11.5976 7.29289 11.2071L3.79289 7.70711C3.40237 7.31658 3.40237 6.68342 3.79289 6.29289C4.18342 5.90237 4.81658 5.90237 5.20711 6.29289Z" } })]);
};
var staticRenderFns$j = [];
var index_vue_vue_type_style_index_0_scoped_true_lang$g = "";
const __vue2_script$j = {
  name: "ArrowDownCircle",
  props: {
    forwadUp: {
      type: Boolean,
      default: false
    }
  }
};
const __cssModules$j = {};
var __component__$j = /* @__PURE__ */ normalizeComponent(
  __vue2_script$j,
  render$j,
  staticRenderFns$j,
  false,
  __vue2_injectStyles$j,
  "41b396b6",
  null,
  null
);
function __vue2_injectStyles$j(context) {
  for (let o in __cssModules$j) {
    this[o] = __cssModules$j[o];
  }
}
var ArrowDownCircle = /* @__PURE__ */ function() {
  return __component__$j.exports;
}();
var render$i = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { class: ["arrow-down", { "arrow-up": _vm.forwadUp }], attrs: { "width": "16", "height": "10", "viewBox": "0 0 16 10", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M-2.18645e-08 0.714274C-1.62914e-08 0.572037 0.0491657 0.42887 0.146665 0.320101C0.341661 0.101632 0.658325 0.101632 0.853323 0.320101L7.76407 8.02972C7.89406 8.17381 8.10573 8.17381 8.23573 8.02972L15.1465 0.320101C15.3415 0.101633 15.6581 0.101633 15.8531 0.320101C16.049 0.53764 16.049 0.890909 15.8531 1.10845L8.94238 8.81806C8.69072 9.09975 8.35572 9.25407 7.9999 9.25407C7.64407 9.25407 7.30907 9.09975 7.05741 8.81806L0.146665 1.10845C0.0491657 0.999677 -2.74376e-08 0.856511 -2.18645e-08 0.714274Z" } })]);
};
var staticRenderFns$i = [];
var index_vue_vue_type_style_index_0_scoped_true_lang$f = "";
const __vue2_script$i = {
  name: "ArrowDown",
  props: {
    forwadUp: {
      type: Boolean,
      default: false
    }
  }
};
const __cssModules$i = {};
var __component__$i = /* @__PURE__ */ normalizeComponent(
  __vue2_script$i,
  render$i,
  staticRenderFns$i,
  false,
  __vue2_injectStyles$i,
  "7ab2f57f",
  null,
  null
);
function __vue2_injectStyles$i(context) {
  for (let o in __cssModules$i) {
    this[o] = __cssModules$i[o];
  }
}
var ArrowDown = /* @__PURE__ */ function() {
  return __component__$i.exports;
}();
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var FUNC_ERROR_TEXT$1 = "Expected a function";
var HASH_UNDEFINED = "__lodash_hash_undefined__";
var INFINITY = 1 / 0;
var funcTag = "[object Function]", genTag = "[object GeneratorFunction]", symbolTag$1 = "[object Symbol]";
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reEscapeChar = /\\(\\)?/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var freeSelf$1 = typeof self == "object" && self && self.Object === Object && self;
var root$1 = freeGlobal$1 || freeSelf$1 || Function("return this")();
function getValue(object, key) {
  return object == null ? void 0 : object[key];
}
function isHostObject(value) {
  var result = false;
  if (value != null && typeof value.toString != "function") {
    try {
      result = !!(value + "");
    } catch (e) {
    }
  }
  return result;
}
var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto$1 = Object.prototype;
var coreJsData = root$1["__core-js_shared__"];
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
var funcToString = funcProto.toString;
var hasOwnProperty = objectProto$1.hasOwnProperty;
var objectToString$1 = objectProto$1.toString;
var reIsNative = RegExp(
  "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
var Symbol$1 = root$1.Symbol, splice = arrayProto.splice;
var Map = getNative(root$1, "Map"), nativeCreate = getNative(Object, "create");
var symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolToString = symbolProto ? symbolProto.toString : void 0;
function Hash(entries) {
  var index2 = -1, length = entries ? entries.length : 0;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}
function hashGet(key) {
  var data2 = this.__data__;
  if (nativeCreate) {
    var result = data2[key];
    return result === HASH_UNDEFINED ? void 0 : result;
  }
  return hasOwnProperty.call(data2, key) ? data2[key] : void 0;
}
function hashHas(key) {
  var data2 = this.__data__;
  return nativeCreate ? data2[key] !== void 0 : hasOwnProperty.call(data2, key);
}
function hashSet(key, value) {
  var data2 = this.__data__;
  data2[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
  return this;
}
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
function ListCache(entries) {
  var index2 = -1, length = entries ? entries.length : 0;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
function listCacheClear() {
  this.__data__ = [];
}
function listCacheDelete(key) {
  var data2 = this.__data__, index2 = assocIndexOf(data2, key);
  if (index2 < 0) {
    return false;
  }
  var lastIndex = data2.length - 1;
  if (index2 == lastIndex) {
    data2.pop();
  } else {
    splice.call(data2, index2, 1);
  }
  return true;
}
function listCacheGet(key) {
  var data2 = this.__data__, index2 = assocIndexOf(data2, key);
  return index2 < 0 ? void 0 : data2[index2][1];
}
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}
function listCacheSet(key, value) {
  var data2 = this.__data__, index2 = assocIndexOf(data2, key);
  if (index2 < 0) {
    data2.push([key, value]);
  } else {
    data2[index2][1] = value;
  }
  return this;
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
function MapCache(entries) {
  var index2 = -1, length = entries ? entries.length : 0;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
function mapCacheClear() {
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map || ListCache)(),
    "string": new Hash()
  };
}
function mapCacheDelete(key) {
  return getMapData(this, key)["delete"](key);
}
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);
  var index2 = 0, length = path.length;
  while (object != null && index2 < length) {
    object = object[toKey(path[index2++])];
  }
  return index2 && index2 == length ? object : void 0;
}
function baseIsNative(value) {
  if (!isObject$2(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$1(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}
function baseToString(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isSymbol$1(value)) {
    return symbolToString ? symbolToString.call(value) : "";
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
function castPath(value) {
  return isArray$1(value) ? value : stringToPath(value);
}
function getMapData(map2, key) {
  var data2 = map2.__data__;
  return isKeyable(key) ? data2[typeof key == "string" ? "string" : "hash"] : data2.map;
}
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : void 0;
}
function isKey(value, object) {
  if (isArray$1(value)) {
    return false;
  }
  var type = typeof value;
  if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol$1(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
function isKeyable(value) {
  var type = typeof value;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var stringToPath = memoize(function(string) {
  string = toString$1(string);
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push("");
  }
  string.replace(rePropName, function(match, number, quote, string2) {
    result.push(quote ? string2.replace(reEscapeChar, "$1") : number || match);
  });
  return result;
});
function toKey(value) {
  if (typeof value == "string" || isSymbol$1(value)) {
    return value;
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {
    }
    try {
      return func + "";
    } catch (e) {
    }
  }
  return "";
}
function memoize(func, resolver) {
  if (typeof func != "function" || resolver && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  var memoized = function() {
    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
}
memoize.Cache = MapCache;
function eq(value, other) {
  return value === other || value !== value && other !== other;
}
var isArray$1 = Array.isArray;
function isFunction$1(value) {
  var tag = isObject$2(value) ? objectToString$1.call(value) : "";
  return tag == funcTag || tag == genTag;
}
function isObject$2(value) {
  var type = typeof value;
  return !!value && (type == "object" || type == "function");
}
function isObjectLike$1(value) {
  return !!value && typeof value == "object";
}
function isSymbol$1(value) {
  return typeof value == "symbol" || isObjectLike$1(value) && objectToString$1.call(value) == symbolTag$1;
}
function toString$1(value) {
  return value == null ? "" : baseToString(value);
}
function get(object, path, defaultValue) {
  var result = object == null ? void 0 : baseGet(object, path);
  return result === void 0 ? defaultValue : result;
}
var lodash_get = get;
var id = {
  header: {
    home: "Home",
    destypage: "desty page",
    destystore: "desty store",
    destyomni: "desty omni",
    destymenu: "desty menu",
    blog: "Blog",
    career: "Karir",
    helpcenter: "Pusat Bantuan",
    dashboard: "Dashboard",
    products: "Produk"
  },
  subHeader: {
    signupBtn: "DAFTAR",
    loginBtn: "MASUK"
  },
  desty: {
    page: "PAGE",
    store: "STORE",
    omni: "DESTY",
    chat: "CHAT",
    wholesale: "WHOLESALE"
  },
  company: {
    abountus: "TENTANG KAMI",
    newsroom: "NEWSROOM",
    investor: "INVESTOR",
    contactus: "HUBUNGI KAMI",
    career: "KARIR",
    blog: "BLOG"
  },
  footer: {
    title1: "PRODUK",
    title2: "PERUSAHAAN",
    title3: "IKUTI KAMI",
    title4: "LANGGANAN NEWSLETTER DESTY",
    subscribeDesc: "BERITA, ARTIKEL, DAN INFORMASI TERBARU DIKIRIM LANGSUNG KE INBOX-MU SETIAP MINGGU.",
    emailPlaceholderText: "MASUKKAN EMAIL",
    emailBtn: "KIRIM",
    privacy: "KEBIJAKAN PRIVASI",
    terms: "SYARAT & KETENTUAN",
    emailErrorText: "Email anda salah"
  },
  privacy: {
    title: "Pembaruan Syarat dan Kebijakan Privasi",
    subTitle: "Dengan pembaruan ini, kami menyediakan informasi yang lebih lengkap di Syarat & Kebijakan Privasi, yang mencakup:",
    desc1: "Bagaimana Desty mengolah data dan menjaga akun kamu untuk tetap aman.",
    desc2: "Bagaimana akun bisnis dapat menggunakan layanan Desty dan mengatur aktivitas pembeli.",
    desc3: "Informasi lengkap mengenai bagaimana Desty memproses transaksi kamu.",
    footerPrefix: "Kamu tidak perlu melakukan tindakan apapun untuk menyetujui",
    footerTerms: "Syarat",
    footerAnd: "dan",
    footerPrivacy: "Kebijakan Privasi",
    footerSubfix: "terbaru. Dengan melanjutkan penggunaan Desty, kamu telah menyetujui kebijakan terbaru ini.",
    okBtn: "OK"
  },
  appRecommend: {
    toolsTitle: "Tools untukmu",
    buildTitle: "Dibuat oleh Desty",
    needTitle: "Tools berdasarkan kebutuhanmu",
    footer: "TEMUKAN LEBIH BANYAK TOOLS DI DESTY MARKET",
    allCategory: "Semua Kategori",
    seeMore: "Lihat semua"
  },
  discovery: {
    title: "Discovery",
    toolTitle: "Tools Untukmu",
    calendarTitle: "Kalender Event"
  },
  marketSelectApp: {
    addMoreText: "Tambah tools lain"
  }
};
var en = {
  header: {
    home: "Home",
    destypage: "desty page",
    destystore: "desty store",
    destyomni: "desty omni",
    destymenu: "desty menu",
    blog: "Blog",
    career: "Career",
    helpcenter: "Help Center",
    dashboard: "Dashboard",
    products: "Products"
  },
  subHeader: {
    signupBtn: "SIGN UP",
    loginBtn: "LOGIN"
  },
  desty: {
    page: "PAGE",
    store: "STORE",
    omni: "DESTY",
    chat: "CHAT",
    wholesale: "WHOLESALE"
  },
  company: {
    abountus: "ABOUT US",
    newsroom: "NEWSROOM",
    investor: "INVESTOR",
    contactus: "CONTACT US",
    career: "CAREER",
    blog: "BLOG"
  },
  footer: {
    title1: "PRODUCTS",
    title2: "COMPANY",
    title3: "FOLLOW US",
    title4: "SUBSCRIBE OUR NEWSLETTER",
    subscribeDesc: "NEWS, ARTICLES, AND NEW INFORMATION WILL SEND IT DIRECTLY TO YOUR EMAIL",
    emailPlaceholderText: "ENTER YOUR EMAIL",
    emailBtn: "SEND",
    privacy: "PRIVACY POLICY",
    terms: "TERMS & CONDITION",
    emailErrorText: "Invalid email address"
  },
  privacy: {
    title: "We\u2019re updating our terms & privacy policy",
    subTitle: "With this update, we\u2019re providing more information in our terms and privacy policy, which includes:",
    desc1: "How we process your data and keep your account safe.",
    desc2: "How businesses can use Desty service and manage buyers interaction.",
    desc3: "More information about how we process your transactions.",
    footerPrefix: "No further action is required to accept the updated",
    footerTerms: "Terms",
    footerAnd: "and",
    footerPrivacy: "Privacy Policy.",
    footerSubfix: "By continuing to use Desty services, you agree to the updated terms.",
    okBtn: "OK"
  },
  appRecommend: {
    toolsTitle: "Tools for you",
    buildTitle: "Built by Desty",
    needTitle: "Tools that you might need",
    footer: "FIND MORE TOOLS IN DESTY MARKET",
    allCategory: "All Category",
    seeMore: "See more"
  },
  discovery: {
    title: "Discovery",
    toolTitle: "Tools For You",
    calendarTitle: "Calendar Event"
  },
  marketSelectApp: {
    addMoreText: "Add more tools"
  }
};
const msgObj = { id, en };
function getLanguage(lang, key) {
  if (!key) {
    throw new Error("key must be exist");
  }
  if (typeof key !== "string") {
    throw new Error("key must be string");
  }
  const value = lodash_get(msgObj[lang], key);
  return value;
}
var FUNC_ERROR_TEXT = "Expected a function";
var NAN = 0 / 0;
var symbolTag = "[object Symbol]";
var reTrim = /^\s+|\s+$/g;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal || freeSelf || Function("return this")();
var objectProto = Object.prototype;
var objectToString = objectProto.toString;
var nativeMax = Math.max, nativeMin = Math.min;
var now = function() {
  return root.Date.now();
};
function debounce(func, wait, options) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject$1(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result2 = wait - timeSinceLastCall;
    return maxing ? nativeMin(result2, maxWait - timeSinceLastInvoke) : result2;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now());
  }
  function debounced() {
    var time = now(), isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
function isObject$1(value) {
  var type = typeof value;
  return !!value && (type == "object" || type == "function");
}
function isObjectLike(value) {
  return !!value && typeof value == "object";
}
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
function toNumber(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject$1(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject$1(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, "");
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var lodash_debounce = debounce;
var axios$2 = { exports: {} };
var bind$2 = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};
var bind$1 = bind$2;
var toString = Object.prototype.toString;
var kindOf = function(cache) {
  return function(thing) {
    var str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
}(/* @__PURE__ */ Object.create(null));
function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf(thing) === type;
  };
}
function isArray(val) {
  return Array.isArray(val);
}
function isUndefined(val) {
  return typeof val === "undefined";
}
function isBuffer$1(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
var isArrayBuffer = kindOfTest("ArrayBuffer");
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && isArrayBuffer(val.buffer);
  }
  return result;
}
function isString(val) {
  return typeof val === "string";
}
function isNumber(val) {
  return typeof val === "number";
}
function isObject(val) {
  return val !== null && typeof val === "object";
}
function isPlainObject(val) {
  if (kindOf(val) !== "object") {
    return false;
  }
  var prototype2 = Object.getPrototypeOf(val);
  return prototype2 === null || prototype2 === Object.prototype;
}
var isDate = kindOfTest("Date");
var isFile = kindOfTest("File");
var isBlob = kindOfTest("Blob");
var isFileList = kindOfTest("FileList");
function isFunction(val) {
  return toString.call(val) === "[object Function]";
}
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}
function isFormData(thing) {
  var pattern = "[object FormData]";
  return thing && (typeof FormData === "function" && thing instanceof FormData || toString.call(thing) === pattern || isFunction(thing.toString) && thing.toString() === pattern);
}
var isURLSearchParams = kindOfTest("URLSearchParams");
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
function isStandardBrowserEnv() {
  if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
    return false;
  }
  return typeof window !== "undefined" && typeof document !== "undefined";
}
function forEach(obj, fn) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }
  if (typeof obj !== "object") {
    obj = [obj];
  }
  if (isArray(obj)) {
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}
function merge() {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }
  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === "function") {
      a[key] = bind$1(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}
function stripBOM(content) {
  if (content.charCodeAt(0) === 65279) {
    content = content.slice(1);
  }
  return content;
}
function inherits(constructor, superConstructor, props, descriptors2) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors2);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}
function toFlatObject(sourceObj, destObj, filter) {
  var props;
  var i;
  var prop;
  var merged = {};
  destObj = destObj || {};
  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if (!merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
  return destObj;
}
function endsWith(str, searchString, position) {
  str = String(str);
  if (position === void 0 || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}
function toArray(thing) {
  if (!thing)
    return null;
  var i = thing.length;
  if (isUndefined(i))
    return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}
var isTypedArray = function(TypedArray) {
  return function(thing) {
    return TypedArray && thing instanceof TypedArray;
  };
}(typeof Uint8Array !== "undefined" && Object.getPrototypeOf(Uint8Array));
var utils$h = {
  isArray,
  isArrayBuffer,
  isBuffer: isBuffer$1,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isFunction,
  isStream,
  isURLSearchParams,
  isStandardBrowserEnv,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  isTypedArray,
  isFileList
};
var utils$g = utils$h;
function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$2 = function buildURL(url, params, paramsSerializer) {
  if (!params) {
    return url;
  }
  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$g.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];
    utils$g.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === "undefined") {
        return;
      }
      if (utils$g.isArray(val)) {
        key = key + "[]";
      } else {
        val = [val];
      }
      utils$g.forEach(val, function parseValue(v) {
        if (utils$g.isDate(v)) {
          v = v.toISOString();
        } else if (utils$g.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + "=" + encode(v));
      });
    });
    serializedParams = parts.join("&");
  }
  if (serializedParams) {
    var hashmarkIndex = url.indexOf("#");
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url;
};
var utils$f = utils$h;
function InterceptorManager$1() {
  this.handlers = [];
}
InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled,
    rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};
InterceptorManager$1.prototype.eject = function eject(id2) {
  if (this.handlers[id2]) {
    this.handlers[id2] = null;
  }
};
InterceptorManager$1.prototype.forEach = function forEach2(fn) {
  utils$f.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};
var InterceptorManager_1 = InterceptorManager$1;
var utils$e = utils$h;
var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
  utils$e.forEach(headers, function processHeader(value, name2) {
    if (name2 !== normalizedName && name2.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name2];
    }
  });
};
var utils$d = utils$h;
function AxiosError$5(message, code, config, request2, response) {
  Error.call(this);
  this.message = message;
  this.name = "AxiosError";
  code && (this.code = code);
  config && (this.config = config);
  request2 && (this.request = request2);
  response && (this.response = response);
}
utils$d.inherits(AxiosError$5, Error, {
  toJSON: function toJSON() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
var prototype = AxiosError$5.prototype;
var descriptors = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED"
].forEach(function(code) {
  descriptors[code] = { value: code };
});
Object.defineProperties(AxiosError$5, descriptors);
Object.defineProperty(prototype, "isAxiosError", { value: true });
AxiosError$5.from = function(error, code, config, request2, response, customProps) {
  var axiosError = Object.create(prototype);
  utils$d.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  });
  AxiosError$5.call(axiosError, error.message, code, config, request2, response);
  axiosError.name = error.name;
  customProps && Object.assign(axiosError, customProps);
  return axiosError;
};
var AxiosError_1 = AxiosError$5;
var transitional = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};
var utils$c = utils$h;
function toFormData$1(obj, formData) {
  formData = formData || new FormData();
  var stack = [];
  function convertValue(value) {
    if (value === null)
      return "";
    if (utils$c.isDate(value)) {
      return value.toISOString();
    }
    if (utils$c.isArrayBuffer(value) || utils$c.isTypedArray(value)) {
      return typeof Blob === "function" ? new Blob([value]) : Buffer.from(value);
    }
    return value;
  }
  function build(data2, parentKey) {
    if (utils$c.isPlainObject(data2) || utils$c.isArray(data2)) {
      if (stack.indexOf(data2) !== -1) {
        throw Error("Circular reference detected in " + parentKey);
      }
      stack.push(data2);
      utils$c.forEach(data2, function each(value, key) {
        if (utils$c.isUndefined(value))
          return;
        var fullKey = parentKey ? parentKey + "." + key : key;
        var arr;
        if (value && !parentKey && typeof value === "object") {
          if (utils$c.endsWith(key, "{}")) {
            value = JSON.stringify(value);
          } else if (utils$c.endsWith(key, "[]") && (arr = utils$c.toArray(value))) {
            arr.forEach(function(el) {
              !utils$c.isUndefined(el) && formData.append(fullKey, convertValue(el));
            });
            return;
          }
        }
        build(value, fullKey);
      });
      stack.pop();
    } else {
      formData.append(parentKey, convertValue(data2));
    }
  }
  build(obj);
  return formData;
}
var toFormData_1 = toFormData$1;
var AxiosError$4 = AxiosError_1;
var settle$1 = function settle(resolve, reject, response) {
  var validateStatus2 = response.config.validateStatus;
  if (!response.status || !validateStatus2 || validateStatus2(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError$4(
      "Request failed with status code " + response.status,
      [AxiosError$4.ERR_BAD_REQUEST, AxiosError$4.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
};
var utils$b = utils$h;
var cookies$1 = utils$b.isStandardBrowserEnv() ? function standardBrowserEnv() {
  return {
    write: function write(name2, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name2 + "=" + encodeURIComponent(value));
      if (utils$b.isNumber(expires)) {
        cookie.push("expires=" + new Date(expires).toGMTString());
      }
      if (utils$b.isString(path)) {
        cookie.push("path=" + path);
      }
      if (utils$b.isString(domain)) {
        cookie.push("domain=" + domain);
      }
      if (secure === true) {
        cookie.push("secure");
      }
      document.cookie = cookie.join("; ");
    },
    read: function read(name2) {
      var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name2 + ")=([^;]*)"));
      return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function remove(name2) {
      this.write(name2, "", Date.now() - 864e5);
    }
  };
}() : function nonStandardBrowserEnv() {
  return {
    write: function write() {
    },
    read: function read() {
      return null;
    },
    remove: function remove() {
    }
  };
}();
var isAbsoluteURL$1 = function isAbsoluteURL(url) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};
var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};
var isAbsoluteURL2 = isAbsoluteURL$1;
var combineURLs2 = combineURLs$1;
var buildFullPath$2 = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL2(requestedURL)) {
    return combineURLs2(baseURL, requestedURL);
  }
  return requestedURL;
};
var utils$a = utils$h;
var ignoreDuplicateOf = [
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
];
var parseHeaders$1 = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;
  if (!headers) {
    return parsed;
  }
  utils$a.forEach(headers.split("\n"), function parser(line) {
    i = line.indexOf(":");
    key = utils$a.trim(line.substr(0, i)).toLowerCase();
    val = utils$a.trim(line.substr(i + 1));
    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === "set-cookie") {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
      }
    }
  });
  return parsed;
};
var utils$9 = utils$h;
var isURLSameOrigin$1 = utils$9.isStandardBrowserEnv() ? function standardBrowserEnv2() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement("a");
  var originURL;
  function resolveURL(url) {
    var href = url;
    if (msie) {
      urlParsingNode.setAttribute("href", href);
      href = urlParsingNode.href;
    }
    urlParsingNode.setAttribute("href", href);
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
    };
  }
  originURL = resolveURL(window.location.href);
  return function isURLSameOrigin2(requestURL) {
    var parsed = utils$9.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : function nonStandardBrowserEnv2() {
  return function isURLSameOrigin2() {
    return true;
  };
}();
var AxiosError$3 = AxiosError_1;
var utils$8 = utils$h;
function CanceledError$3(message) {
  AxiosError$3.call(this, message == null ? "canceled" : message, AxiosError$3.ERR_CANCELED);
  this.name = "CanceledError";
}
utils$8.inherits(CanceledError$3, AxiosError$3, {
  __CANCEL__: true
});
var CanceledError_1 = CanceledError$3;
var parseProtocol$1 = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || "";
};
var utils$7 = utils$h;
var settle2 = settle$1;
var cookies = cookies$1;
var buildURL$1 = buildURL$2;
var buildFullPath$1 = buildFullPath$2;
var parseHeaders2 = parseHeaders$1;
var isURLSameOrigin = isURLSameOrigin$1;
var transitionalDefaults$1 = transitional;
var AxiosError$2 = AxiosError_1;
var CanceledError$2 = CanceledError_1;
var parseProtocol2 = parseProtocol$1;
var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }
      if (config.signal) {
        config.signal.removeEventListener("abort", onCanceled);
      }
    }
    if (utils$7.isFormData(requestData) && utils$7.isStandardBrowserEnv()) {
      delete requestHeaders["Content-Type"];
    }
    var request2 = new XMLHttpRequest();
    if (config.auth) {
      var username = config.auth.username || "";
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
      requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
    }
    var fullPath = buildFullPath$1(config.baseURL, config.url);
    request2.open(config.method.toUpperCase(), buildURL$1(fullPath, config.params, config.paramsSerializer), true);
    request2.timeout = config.timeout;
    function onloadend() {
      if (!request2) {
        return;
      }
      var responseHeaders = "getAllResponseHeaders" in request2 ? parseHeaders2(request2.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === "text" || responseType === "json" ? request2.responseText : request2.response;
      var response = {
        data: responseData,
        status: request2.status,
        statusText: request2.statusText,
        headers: responseHeaders,
        config,
        request: request2
      };
      settle2(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);
      request2 = null;
    }
    if ("onloadend" in request2) {
      request2.onloadend = onloadend;
    } else {
      request2.onreadystatechange = function handleLoad() {
        if (!request2 || request2.readyState !== 4) {
          return;
        }
        if (request2.status === 0 && !(request2.responseURL && request2.responseURL.indexOf("file:") === 0)) {
          return;
        }
        setTimeout(onloadend);
      };
    }
    request2.onabort = function handleAbort() {
      if (!request2) {
        return;
      }
      reject(new AxiosError$2("Request aborted", AxiosError$2.ECONNABORTED, config, request2));
      request2 = null;
    };
    request2.onerror = function handleError() {
      reject(new AxiosError$2("Network Error", AxiosError$2.ERR_NETWORK, config, request2, request2));
      request2 = null;
    };
    request2.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
      var transitional3 = config.transitional || transitionalDefaults$1;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError$2(
        timeoutErrorMessage,
        transitional3.clarifyTimeoutError ? AxiosError$2.ETIMEDOUT : AxiosError$2.ECONNABORTED,
        config,
        request2
      ));
      request2 = null;
    };
    if (utils$7.isStandardBrowserEnv()) {
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : void 0;
      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }
    if ("setRequestHeader" in request2) {
      utils$7.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
          delete requestHeaders[key];
        } else {
          request2.setRequestHeader(key, val);
        }
      });
    }
    if (!utils$7.isUndefined(config.withCredentials)) {
      request2.withCredentials = !!config.withCredentials;
    }
    if (responseType && responseType !== "json") {
      request2.responseType = config.responseType;
    }
    if (typeof config.onDownloadProgress === "function") {
      request2.addEventListener("progress", config.onDownloadProgress);
    }
    if (typeof config.onUploadProgress === "function" && request2.upload) {
      request2.upload.addEventListener("progress", config.onUploadProgress);
    }
    if (config.cancelToken || config.signal) {
      onCanceled = function(cancel) {
        if (!request2) {
          return;
        }
        reject(!cancel || cancel && cancel.type ? new CanceledError$2() : cancel);
        request2.abort();
        request2 = null;
      };
      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
      }
    }
    if (!requestData) {
      requestData = null;
    }
    var protocol = parseProtocol2(fullPath);
    if (protocol && ["http", "https", "file"].indexOf(protocol) === -1) {
      reject(new AxiosError$2("Unsupported protocol " + protocol + ":", AxiosError$2.ERR_BAD_REQUEST, config));
      return;
    }
    request2.send(requestData);
  });
};
var _null = null;
var utils$6 = utils$h;
var normalizeHeaderName2 = normalizeHeaderName$1;
var AxiosError$1 = AxiosError_1;
var transitionalDefaults = transitional;
var toFormData = toFormData_1;
var DEFAULT_CONTENT_TYPE = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset(headers, value) {
  if (!utils$6.isUndefined(headers) && utils$6.isUndefined(headers["Content-Type"])) {
    headers["Content-Type"] = value;
  }
}
function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== "undefined") {
    adapter = xhr;
  } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
    adapter = xhr;
  }
  return adapter;
}
function stringifySafely(rawValue, parser, encoder) {
  if (utils$6.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$6.trim(rawValue);
    } catch (e) {
      if (e.name !== "SyntaxError") {
        throw e;
      }
    }
  }
  return (encoder || JSON.stringify)(rawValue);
}
var defaults$3 = {
  transitional: transitionalDefaults,
  adapter: getDefaultAdapter(),
  transformRequest: [function transformRequest(data2, headers) {
    normalizeHeaderName2(headers, "Accept");
    normalizeHeaderName2(headers, "Content-Type");
    if (utils$6.isFormData(data2) || utils$6.isArrayBuffer(data2) || utils$6.isBuffer(data2) || utils$6.isStream(data2) || utils$6.isFile(data2) || utils$6.isBlob(data2)) {
      return data2;
    }
    if (utils$6.isArrayBufferView(data2)) {
      return data2.buffer;
    }
    if (utils$6.isURLSearchParams(data2)) {
      setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
      return data2.toString();
    }
    var isObjectPayload = utils$6.isObject(data2);
    var contentType = headers && headers["Content-Type"];
    var isFileList2;
    if ((isFileList2 = utils$6.isFileList(data2)) || isObjectPayload && contentType === "multipart/form-data") {
      var _FormData = this.env && this.env.FormData;
      return toFormData(isFileList2 ? { "files[]": data2 } : data2, _FormData && new _FormData());
    } else if (isObjectPayload || contentType === "application/json") {
      setContentTypeIfUnset(headers, "application/json");
      return stringifySafely(data2);
    }
    return data2;
  }],
  transformResponse: [function transformResponse(data2) {
    var transitional3 = this.transitional || defaults$3.transitional;
    var silentJSONParsing = transitional3 && transitional3.silentJSONParsing;
    var forcedJSONParsing = transitional3 && transitional3.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
    if (strictJSONParsing || forcedJSONParsing && utils$6.isString(data2) && data2.length) {
      try {
        return JSON.parse(data2);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === "SyntaxError") {
            throw AxiosError$1.from(e, AxiosError$1.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }
    return data2;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: _null
  },
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      "Accept": "application/json, text/plain, */*"
    }
  }
};
utils$6.forEach(["delete", "get", "head"], function forEachMethodNoData(method) {
  defaults$3.headers[method] = {};
});
utils$6.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
  defaults$3.headers[method] = utils$6.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults$3;
var utils$5 = utils$h;
var defaults$2 = defaults_1;
var transformData$1 = function transformData(data2, headers, fns) {
  var context = this || defaults$2;
  utils$5.forEach(fns, function transform(fn) {
    data2 = fn.call(context, data2, headers);
  });
  return data2;
};
var isCancel$1 = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};
var utils$4 = utils$h;
var transformData2 = transformData$1;
var isCancel2 = isCancel$1;
var defaults$1 = defaults_1;
var CanceledError$1 = CanceledError_1;
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
  if (config.signal && config.signal.aborted) {
    throw new CanceledError$1();
  }
}
var dispatchRequest$1 = function dispatchRequest(config) {
  throwIfCancellationRequested(config);
  config.headers = config.headers || {};
  config.data = transformData2.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );
  config.headers = utils$4.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );
  utils$4.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );
  var adapter = config.adapter || defaults$1.adapter;
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);
    response.data = transformData2.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel2(reason)) {
      throwIfCancellationRequested(config);
      if (reason && reason.response) {
        reason.response.data = transformData2.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }
    return Promise.reject(reason);
  });
};
var utils$3 = utils$h;
var mergeConfig$2 = function mergeConfig(config1, config2) {
  config2 = config2 || {};
  var config = {};
  function getMergedValue(target, source2) {
    if (utils$3.isPlainObject(target) && utils$3.isPlainObject(source2)) {
      return utils$3.merge(target, source2);
    } else if (utils$3.isPlainObject(source2)) {
      return utils$3.merge({}, source2);
    } else if (utils$3.isArray(source2)) {
      return source2.slice();
    }
    return source2;
  }
  function mergeDeepProperties(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$3.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function valueFromConfig2(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    }
  }
  function defaultToConfig2(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    } else if (!utils$3.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  var mergeMap = {
    "url": valueFromConfig2,
    "method": valueFromConfig2,
    "data": valueFromConfig2,
    "baseURL": defaultToConfig2,
    "transformRequest": defaultToConfig2,
    "transformResponse": defaultToConfig2,
    "paramsSerializer": defaultToConfig2,
    "timeout": defaultToConfig2,
    "timeoutMessage": defaultToConfig2,
    "withCredentials": defaultToConfig2,
    "adapter": defaultToConfig2,
    "responseType": defaultToConfig2,
    "xsrfCookieName": defaultToConfig2,
    "xsrfHeaderName": defaultToConfig2,
    "onUploadProgress": defaultToConfig2,
    "onDownloadProgress": defaultToConfig2,
    "decompress": defaultToConfig2,
    "maxContentLength": defaultToConfig2,
    "maxBodyLength": defaultToConfig2,
    "beforeRedirect": defaultToConfig2,
    "transport": defaultToConfig2,
    "httpAgent": defaultToConfig2,
    "httpsAgent": defaultToConfig2,
    "cancelToken": defaultToConfig2,
    "socketPath": defaultToConfig2,
    "responseEncoding": defaultToConfig2,
    "validateStatus": mergeDirectKeys
  };
  utils$3.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge2 = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge2(prop);
    utils$3.isUndefined(configValue) && merge2 !== mergeDirectKeys || (config[prop] = configValue);
  });
  return config;
};
var data = {
  "version": "0.27.2"
};
var VERSION = data.version;
var AxiosError = AxiosError_1;
var validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type, i) {
  validators$1[type] = function validator2(thing) {
    return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
  };
});
var deprecatedWarnings = {};
validators$1.transitional = function transitional2(validator2, version, message) {
  function formatMessage(opt, desc) {
    return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
  }
  return function(value, opt, opts) {
    if (validator2 === false) {
      throw new AxiosError(
        formatMessage(opt, " has been removed" + (version ? " in " + version : "")),
        AxiosError.ERR_DEPRECATED
      );
    }
    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      console.warn(
        formatMessage(
          opt,
          " has been deprecated since v" + version + " and will be removed in the near future"
        )
      );
    }
    return validator2 ? validator2(value, opt, opts) : true;
  };
};
function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== "object") {
    throw new AxiosError("options must be an object", AxiosError.ERR_BAD_OPTION_VALUE);
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator2 = schema[opt];
    if (validator2) {
      var value = options[opt];
      var result = value === void 0 || validator2(value, opt, options);
      if (result !== true) {
        throw new AxiosError("option " + opt + " must be " + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError("Unknown option " + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}
var validator$1 = {
  assertOptions,
  validators: validators$1
};
var utils$2 = utils$h;
var buildURL2 = buildURL$2;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest2 = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var buildFullPath2 = buildFullPath$2;
var validator = validator$1;
var validators = validator.validators;
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}
Axios$1.prototype.request = function request(configOrUrl, config) {
  if (typeof configOrUrl === "string") {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }
  config = mergeConfig$1(this.defaults, config);
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = "get";
  }
  var transitional3 = config.transitional;
  if (transitional3 !== void 0) {
    validator.assertOptions(transitional3, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
      return;
    }
    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });
  var promise;
  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest2, void 0];
    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);
    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }
    return promise;
  }
  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }
  try {
    promise = dispatchRequest2(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }
  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }
  return promise;
};
Axios$1.prototype.getUri = function getUri(config) {
  config = mergeConfig$1(this.defaults, config);
  var fullPath = buildFullPath2(config.baseURL, config.url);
  return buildURL2(fullPath, config.params, config.paramsSerializer);
};
utils$2.forEach(["delete", "get", "head", "options"], function forEachMethodNoData2(method) {
  Axios$1.prototype[method] = function(url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});
utils$2.forEach(["post", "put", "patch"], function forEachMethodWithData2(method) {
  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data2, config) {
      return this.request(mergeConfig$1(config || {}, {
        method,
        headers: isForm ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url,
        data: data2
      }));
    };
  }
  Axios$1.prototype[method] = generateHTTPMethod();
  Axios$1.prototype[method + "Form"] = generateHTTPMethod(true);
});
var Axios_1 = Axios$1;
var CanceledError = CanceledError_1;
function CancelToken(executor) {
  if (typeof executor !== "function") {
    throw new TypeError("executor must be a function.");
  }
  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });
  var token = this;
  this.promise.then(function(cancel) {
    if (!token._listeners)
      return;
    var i;
    var l = token._listeners.length;
    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });
  this.promise.then = function(onfulfilled) {
    var _resolve;
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);
    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };
    return promise;
  };
  executor(function cancel(message) {
    if (token.reason) {
      return;
    }
    token.reason = new CanceledError(message);
    resolvePromise(token.reason);
  });
}
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};
CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }
  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};
CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index2 = this._listeners.indexOf(listener);
  if (index2 !== -1) {
    this._listeners.splice(index2, 1);
  }
};
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token,
    cancel
  };
};
var CancelToken_1 = CancelToken;
var spread = function spread2(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};
var utils$1 = utils$h;
var isAxiosError = function isAxiosError2(payload) {
  return utils$1.isObject(payload) && payload.isAxiosError === true;
};
var utils = utils$h;
var bind2 = bind$2;
var Axios = Axios_1;
var mergeConfig2 = mergeConfig$2;
var defaults = defaults_1;
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind2(Axios.prototype.request, context);
  utils.extend(instance, Axios.prototype, context);
  utils.extend(instance, context);
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig2(defaultConfig, instanceConfig));
  };
  return instance;
}
var axios$1 = createInstance(defaults);
axios$1.Axios = Axios;
axios$1.CanceledError = CanceledError_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel$1;
axios$1.VERSION = data.version;
axios$1.toFormData = toFormData_1;
axios$1.AxiosError = AxiosError_1;
axios$1.Cancel = axios$1.CanceledError;
axios$1.all = function all(promises) {
  return Promise.all(promises);
};
axios$1.spread = spread;
axios$1.isAxiosError = isAxiosError;
axios$2.exports = axios$1;
axios$2.exports.default = axios$1;
var axios = axios$2.exports;
var md5$1 = { exports: {} };
var crypt = { exports: {} };
(function() {
  var base64map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", crypt$1 = {
    rotl: function(n, b) {
      return n << b | n >>> 32 - b;
    },
    rotr: function(n, b) {
      return n << 32 - b | n >>> b;
    },
    endian: function(n) {
      if (n.constructor == Number) {
        return crypt$1.rotl(n, 8) & 16711935 | crypt$1.rotl(n, 24) & 4278255360;
      }
      for (var i = 0; i < n.length; i++)
        n[i] = crypt$1.endian(n[i]);
      return n;
    },
    randomBytes: function(n) {
      for (var bytes = []; n > 0; n--)
        bytes.push(Math.floor(Math.random() * 256));
      return bytes;
    },
    bytesToWords: function(bytes) {
      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
        words[b >>> 5] |= bytes[i] << 24 - b % 32;
      return words;
    },
    wordsToBytes: function(words) {
      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
        bytes.push(words[b >>> 5] >>> 24 - b % 32 & 255);
      return bytes;
    },
    bytesToHex: function(bytes) {
      for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 15).toString(16));
      }
      return hex.join("");
    },
    hexToBytes: function(hex) {
      for (var bytes = [], c = 0; c < hex.length; c += 2)
        bytes.push(parseInt(hex.substr(c, 2), 16));
      return bytes;
    },
    bytesToBase64: function(bytes) {
      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
        var triplet = bytes[i] << 16 | bytes[i + 1] << 8 | bytes[i + 2];
        for (var j = 0; j < 4; j++)
          if (i * 8 + j * 6 <= bytes.length * 8)
            base64.push(base64map.charAt(triplet >>> 6 * (3 - j) & 63));
          else
            base64.push("=");
      }
      return base64.join("");
    },
    base64ToBytes: function(base64) {
      base64 = base64.replace(/[^A-Z0-9+\/]/ig, "");
      for (var bytes = [], i = 0, imod4 = 0; i < base64.length; imod4 = ++i % 4) {
        if (imod4 == 0)
          continue;
        bytes.push((base64map.indexOf(base64.charAt(i - 1)) & Math.pow(2, -2 * imod4 + 8) - 1) << imod4 * 2 | base64map.indexOf(base64.charAt(i)) >>> 6 - imod4 * 2);
      }
      return bytes;
    }
  };
  crypt.exports = crypt$1;
})();
var charenc = {
  utf8: {
    stringToBytes: function(str) {
      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
    },
    bytesToString: function(bytes) {
      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
    }
  },
  bin: {
    stringToBytes: function(str) {
      for (var bytes = [], i = 0; i < str.length; i++)
        bytes.push(str.charCodeAt(i) & 255);
      return bytes;
    },
    bytesToString: function(bytes) {
      for (var str = [], i = 0; i < bytes.length; i++)
        str.push(String.fromCharCode(bytes[i]));
      return str.join("");
    }
  }
};
var charenc_1 = charenc;
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var isBuffer_1 = function(obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
};
function isBuffer(obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
}
function isSlowBuffer(obj) {
  return typeof obj.readFloatLE === "function" && typeof obj.slice === "function" && isBuffer(obj.slice(0, 0));
}
(function() {
  var crypt$1 = crypt.exports, utf8 = charenc_1.utf8, isBuffer2 = isBuffer_1, bin = charenc_1.bin, md52 = function(message, options) {
    if (message.constructor == String)
      if (options && options.encoding === "binary")
        message = bin.stringToBytes(message);
      else
        message = utf8.stringToBytes(message);
    else if (isBuffer2(message))
      message = Array.prototype.slice.call(message, 0);
    else if (!Array.isArray(message) && message.constructor !== Uint8Array)
      message = message.toString();
    var m = crypt$1.bytesToWords(message), l = message.length * 8, a = 1732584193, b = -271733879, c = -1732584194, d = 271733878;
    for (var i = 0; i < m.length; i++) {
      m[i] = (m[i] << 8 | m[i] >>> 24) & 16711935 | (m[i] << 24 | m[i] >>> 8) & 4278255360;
    }
    m[l >>> 5] |= 128 << l % 32;
    m[(l + 64 >>> 9 << 4) + 14] = l;
    var FF = md52._ff, GG = md52._gg, HH = md52._hh, II = md52._ii;
    for (var i = 0; i < m.length; i += 16) {
      var aa = a, bb = b, cc = c, dd = d;
      a = FF(a, b, c, d, m[i + 0], 7, -680876936);
      d = FF(d, a, b, c, m[i + 1], 12, -389564586);
      c = FF(c, d, a, b, m[i + 2], 17, 606105819);
      b = FF(b, c, d, a, m[i + 3], 22, -1044525330);
      a = FF(a, b, c, d, m[i + 4], 7, -176418897);
      d = FF(d, a, b, c, m[i + 5], 12, 1200080426);
      c = FF(c, d, a, b, m[i + 6], 17, -1473231341);
      b = FF(b, c, d, a, m[i + 7], 22, -45705983);
      a = FF(a, b, c, d, m[i + 8], 7, 1770035416);
      d = FF(d, a, b, c, m[i + 9], 12, -1958414417);
      c = FF(c, d, a, b, m[i + 10], 17, -42063);
      b = FF(b, c, d, a, m[i + 11], 22, -1990404162);
      a = FF(a, b, c, d, m[i + 12], 7, 1804603682);
      d = FF(d, a, b, c, m[i + 13], 12, -40341101);
      c = FF(c, d, a, b, m[i + 14], 17, -1502002290);
      b = FF(b, c, d, a, m[i + 15], 22, 1236535329);
      a = GG(a, b, c, d, m[i + 1], 5, -165796510);
      d = GG(d, a, b, c, m[i + 6], 9, -1069501632);
      c = GG(c, d, a, b, m[i + 11], 14, 643717713);
      b = GG(b, c, d, a, m[i + 0], 20, -373897302);
      a = GG(a, b, c, d, m[i + 5], 5, -701558691);
      d = GG(d, a, b, c, m[i + 10], 9, 38016083);
      c = GG(c, d, a, b, m[i + 15], 14, -660478335);
      b = GG(b, c, d, a, m[i + 4], 20, -405537848);
      a = GG(a, b, c, d, m[i + 9], 5, 568446438);
      d = GG(d, a, b, c, m[i + 14], 9, -1019803690);
      c = GG(c, d, a, b, m[i + 3], 14, -187363961);
      b = GG(b, c, d, a, m[i + 8], 20, 1163531501);
      a = GG(a, b, c, d, m[i + 13], 5, -1444681467);
      d = GG(d, a, b, c, m[i + 2], 9, -51403784);
      c = GG(c, d, a, b, m[i + 7], 14, 1735328473);
      b = GG(b, c, d, a, m[i + 12], 20, -1926607734);
      a = HH(a, b, c, d, m[i + 5], 4, -378558);
      d = HH(d, a, b, c, m[i + 8], 11, -2022574463);
      c = HH(c, d, a, b, m[i + 11], 16, 1839030562);
      b = HH(b, c, d, a, m[i + 14], 23, -35309556);
      a = HH(a, b, c, d, m[i + 1], 4, -1530992060);
      d = HH(d, a, b, c, m[i + 4], 11, 1272893353);
      c = HH(c, d, a, b, m[i + 7], 16, -155497632);
      b = HH(b, c, d, a, m[i + 10], 23, -1094730640);
      a = HH(a, b, c, d, m[i + 13], 4, 681279174);
      d = HH(d, a, b, c, m[i + 0], 11, -358537222);
      c = HH(c, d, a, b, m[i + 3], 16, -722521979);
      b = HH(b, c, d, a, m[i + 6], 23, 76029189);
      a = HH(a, b, c, d, m[i + 9], 4, -640364487);
      d = HH(d, a, b, c, m[i + 12], 11, -421815835);
      c = HH(c, d, a, b, m[i + 15], 16, 530742520);
      b = HH(b, c, d, a, m[i + 2], 23, -995338651);
      a = II(a, b, c, d, m[i + 0], 6, -198630844);
      d = II(d, a, b, c, m[i + 7], 10, 1126891415);
      c = II(c, d, a, b, m[i + 14], 15, -1416354905);
      b = II(b, c, d, a, m[i + 5], 21, -57434055);
      a = II(a, b, c, d, m[i + 12], 6, 1700485571);
      d = II(d, a, b, c, m[i + 3], 10, -1894986606);
      c = II(c, d, a, b, m[i + 10], 15, -1051523);
      b = II(b, c, d, a, m[i + 1], 21, -2054922799);
      a = II(a, b, c, d, m[i + 8], 6, 1873313359);
      d = II(d, a, b, c, m[i + 15], 10, -30611744);
      c = II(c, d, a, b, m[i + 6], 15, -1560198380);
      b = II(b, c, d, a, m[i + 13], 21, 1309151649);
      a = II(a, b, c, d, m[i + 4], 6, -145523070);
      d = II(d, a, b, c, m[i + 11], 10, -1120210379);
      c = II(c, d, a, b, m[i + 2], 15, 718787259);
      b = II(b, c, d, a, m[i + 9], 21, -343485551);
      a = a + aa >>> 0;
      b = b + bb >>> 0;
      c = c + cc >>> 0;
      d = d + dd >>> 0;
    }
    return crypt$1.endian([a, b, c, d]);
  };
  md52._ff = function(a, b, c, d, x, s, t) {
    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
    return (n << s | n >>> 32 - s) + b;
  };
  md52._gg = function(a, b, c, d, x, s, t) {
    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
    return (n << s | n >>> 32 - s) + b;
  };
  md52._hh = function(a, b, c, d, x, s, t) {
    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
    return (n << s | n >>> 32 - s) + b;
  };
  md52._ii = function(a, b, c, d, x, s, t) {
    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
    return (n << s | n >>> 32 - s) + b;
  };
  md52._blocksize = 16;
  md52._digestsize = 16;
  md5$1.exports = function(message, options) {
    if (message === void 0 || message === null)
      throw new Error("Illegal argument " + message);
    var digestbytes = crypt$1.wordsToBytes(md52(message, options));
    return options && options.asBytes ? digestbytes : options && options.asString ? bin.bytesToString(digestbytes) : crypt$1.bytesToHex(digestbytes);
  };
})();
var md5 = md5$1.exports;
class Tracker {
  constructor(host, project, logstore) {
    this.uri = `https://${project}.${host}/logstores/${logstore}/track?APIVersion=0.6.0`;
    this.params = {};
  }
  push(key, value) {
    if (!key || !value) {
      return false;
    }
    this.params[key] = value;
  }
  logger() {
    let queryString = "&";
    const params = {};
    Object.keys(this.params).forEach((key) => {
      params[key] = encodeURIComponent(this.params[key]);
      queryString += `${key}=${encodeURIComponent(this.params[key])}&`;
    });
    queryString += `data=${JSON.stringify(params)}`;
    const image = new Image();
    image.src = this.uri + queryString;
  }
}
const TrackerConfig = [
  "ap-southeast-5.log.aliyuncs.com",
  "desty-prod-logs",
  "desty-login-signup"
];
const createTracker = function(config) {
  const tracker = new Tracker(...config);
  let did = localStorage.getItem("sls_did");
  if (!did) {
    did = md5(`${navigator.userAgent}${+new Date()}${Math.random() * 999999999}`);
    localStorage.setItem("sls_did", did);
  }
  tracker.params = {
    location: window.location.href,
    did,
    agent: navigator.userAgent
  };
  return tracker;
};
const pushLog = (data2 = {}) => {
  const tracker = createTracker(TrackerConfig);
  tracker.push("timeStamp", +new Date());
  for (const i in data2) {
    tracker.push(i, data2[i]);
  }
  tracker.logger();
};
const CLIENT_WIDTH = 768;
const WAIT_MS = 150;
function resizeScreen(mbcb, pccb, width = CLIENT_WIDTH) {
  if (document.body.clientWidth < width) {
    if (typeof mbcb === "function") {
      mbcb();
    }
  }
  function cbFunc() {
    if (document.body.clientWidth < width) {
      if (typeof mbcb === "function") {
        mbcb();
      }
    } else {
      if (typeof pccb === "function") {
        pccb();
      }
    }
  }
  const _debounce = lodash_debounce(cbFunc, WAIT_MS);
  window.addEventListener("resize", _debounce, false);
  return () => {
    window.removeEventListener("resize", _debounce, false);
  };
}
function watchScroll(cb) {
  const cbFunc = () => {
    cb();
  };
  window.addEventListener("scroll", cbFunc, false);
  return () => {
    window.removeEventListener("scroll", cbFunc, false);
  };
}
async function _handleGetDomainList(env, val) {
  try {
    const res = await axios({
      url: "https://www.desty.app/api/lex/domains",
      method: "get"
    });
    return (res == null ? void 0 : res.data) || {};
  } catch (error) {
    pushLog({
      key: "desty-design[_handleGetDomainList catch error]",
      sourceParams: JSON.stringify({ env, val }),
      result: new Error(error).message
    });
    console.log("_handleGetDomainList", error);
  }
}
async function setDomianCookie(env, val) {
  const DOMAIN_MAP = await _handleGetDomainList(env, val);
  const domains = DOMAIN_MAP[env] || [];
  pushLog({
    key: "desty-design[setDomianCookie get domains]",
    domains: JSON.stringify(domains),
    sourceParams: JSON.stringify({ env, val })
  });
  const promiseList = [];
  for (const item of domains) {
    promiseList.push(
      new Promise((resolve) => {
        let img = new Image();
        img.onload = () => {
          img = null;
          resolve(true);
        };
        img.onerror = () => {
          img = null;
          resolve(true);
        };
        img.src = `${item.domain}/new-api/platform/user/sso/setCookie?value=${val}`;
      })
    );
  }
  return Promise.allSettled(promiseList);
}
function outsideClick(selectors = [], cb) {
  function clickEvent(event) {
    const target = event.target;
    const resArr = selectors.map((item) => {
      return !target.closest(item);
    });
    if (resArr.includes(false))
      return false;
    cb();
  }
  document.addEventListener("click", clickEvent, false);
  return () => {
    window.removeEventListener("click", clickEvent, false);
  };
}
var render$h = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "desty-header" }, [_c("div", { class: ["main-header", { "main-header-border": _vm.showSubHeader }] }, [_c("img", { staticClass: "header-logo", attrs: { "src": _vm.logo, "alt": "desty-logo" }, on: { "click": function($event) {
    return _vm.handleNav("mainLogo");
  } } }), !_vm.isMobile ? _c("nav", { staticClass: "nav" }, _vm._l(_vm.navList, function(item) {
    return _c("span", { key: item.key, class: ["nav-item", { "nav-item-sub-menu-v1": item.hasSubMenu }], attrs: { "id": "nav-item-" + item.key }, on: { "click": function($event) {
      return _vm.handleNav(item.key, item.hasSubMenu);
    } } }, [_c("div", { class: ["nav-text", { "active-nav-text": _vm.navKey === item.key }] }, [_vm._v(" " + _vm._s(item.label) + " ")]), _c("div", { directives: [{ name: "show", rawName: "v-show", value: item.hasSubMenu && _vm.showPopSubMenu, expression: "item.hasSubMenu && showPopSubMenu" }], staticClass: "pop-sub-menu", attrs: { "id": "pop-sub-menu-" + item.key }, on: { "click": function($event) {
      $event.preventDefault();
      $event.stopPropagation();
      _vm.showPopSubMenu = !_vm.showPopSubMenu;
    } } }, [_vm._t("sub-menu-" + item.key + "-content", function() {
      return [_vm._v(" sub-menu-" + _vm._s(item.key) + "-content ")];
    })], 2), item.hasSubMenu ? _c("ArrowDownCircle") : _vm._e()], 1);
  }), 0) : _vm._e(), _c("div", { staticClass: "language-box" }, [_vm._l(_vm.langs, function(item) {
    return _c("span", { key: item.key, class: [
      "lang-item",
      { "active-lang-item": _vm.activeLangKey === item.key }
    ], on: { "click": function($event) {
      return _vm.handleLang(item.key);
    } } }, [_vm._v(_vm._s(item.label))]);
  }), _vm.isMobile ? _c("Menu", { staticClass: "menu-icon", nativeOn: { "click": function($event) {
    return _vm.handleShowMenuDialog.apply(null, arguments);
  } } }) : _vm._e()], 2)]), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.subHeaderFixed, expression: "subHeaderFixed" }], staticClass: "placeholder" }), _vm.showSubHeader ? _c("div", { class: ["sub-header", { "sub-header-fixed": _vm.subHeaderFixed }] }, [_c("div", { staticClass: "sub-header-content" }, [_c("div", { staticClass: "left-action-box" }, [_c("img", { staticClass: "sub-header-logo", attrs: { "src": _vm.subLogo, "alt": "desty" }, on: { "click": function($event) {
    return _vm.handleNav("subLogo");
  } } }), _vm.isMobile && _vm.extraLinks.length ? _c("ArrowDown", { class: [
    "sub-header-arrow-down",
    { "sub-header-arrow-down-reverse": _vm.isShowSubHeaderDrawer }
  ], nativeOn: { "click": function($event) {
    return _vm.handleExtraLinks.apply(null, arguments);
  } } }) : _vm._e()], 1), _c("div", { staticClass: "right-action-box" }, [_vm._t("sub-header-action", function() {
    return [!_vm.isMobile ? _c("div", { staticClass: "extra-links" }, _vm._l(_vm.extraLinks, function(item) {
      return _c("div", { key: item.key, staticClass: "nav-text", on: { "click": function($event) {
        return _vm.handleNav(item.key);
      } } }, [_vm._v(" " + _vm._s(item.label) + " ")]);
    }), 0) : _vm._e(), _vm.isLogin ? _c("span", { staticClass: "dashboard-btn", on: { "click": function($event) {
      return _vm.handleAction("dashboard");
    } } }, [_vm._v(" " + _vm._s(_vm.$t("header.dashboard")) + " ")]) : _vm._l(_vm.rightActionBtns, function(item) {
      return _c("span", { key: item.key, class: [
        "action-item",
        { "active-login-item": item.key === "login" }
      ], on: { "click": function($event) {
        return _vm.handleAction(item.key);
      } } }, [_vm._v(_vm._s(item.label))]);
    })];
  })], 2)]), _vm.isMobile ? _c("div", { class: ["drawer-box", { "drawer-box-down": _vm.isShowSubHeaderDrawer }] }, _vm._l(_vm.extraLinks, function(item) {
    return _c("div", { key: item.key, staticClass: "nav-text", on: { "click": function($event) {
      return _vm.handleNav(item.key);
    } } }, [_vm._v(" " + _vm._s(item.label) + " ")]);
  }), 0) : _vm._e()]) : _vm._e(), _vm.isMobile ? _c("div", { class: ["mobile-menu-dialog", { "mobile-menu-dialog-show": _vm.isShow }] }, [_c("header", { staticClass: "header" }, [_c("img", { staticClass: "mobile-header-logo", attrs: { "src": _vm.logo, "alt": "desty-logo" }, on: { "click": function($event) {
    return _vm.handleNav("mainLogo");
  } } }), _c("div", { staticClass: "mobile-language-box" }, [_vm._l(_vm.langs, function(item) {
    return _c("span", { key: item.key, class: [
      "mobile-lang-item",
      { "mobile-active-lang-item": _vm.activeLangKey === item.key }
    ], on: { "click": function($event) {
      return _vm.handleLang(item.key);
    } } }, [_vm._v(_vm._s(item.label))]);
  }), _c("Close", { nativeOn: { "click": function($event) {
    return _vm.handleCloseMenuDialog.apply(null, arguments);
  } } })], 2)]), _c("div", { staticClass: "mobile-nav" }, _vm._l(_vm.navList, function(item) {
    return _c("div", { key: item.key, staticClass: "mobile-nav-item", on: { "click": function($event) {
      return _vm.handleNav(item.key, item.hasSubMenu);
    } } }, [_c("div", { class: ["nav-text", { "active-nav-text": _vm.navKey === item.key }] }, [_vm._v(" " + _vm._s(item.label) + " ")]), item.hasSubMenu ? _c("ArrowDownCircle") : _vm._e(), item.hasSubMenu && _vm.showPopSubMenu ? _c("div", { staticClass: "sub-menu-slot" }, [_vm._t("mobile-sub-menu-" + item.key + "-content", function() {
      return [_vm._v(" mobile-sub-menu-" + _vm._s(item.key) + "-content ")];
    })], 2) : _vm._e()], 1);
  }), 0), _c("footer", { staticClass: "footer" }, [_vm._v(" Copyright \xA9 " + _vm._s(_vm.currentYear) + " desty. All rights reserved. ")])]) : _vm._e()]);
};
var staticRenderFns$h = [];
var index_vue_vue_type_style_index_0_scoped_true_lang$e = "";
const __vue2_script$h = {
  name: "DestyHeader",
  data() {
    return {
      subHeaderFixed: false,
      activeLangKey: "id",
      activeActionKey: "login",
      langs: [
        {
          label: "ID",
          key: "id"
        },
        {
          label: "EN",
          key: "en"
        }
      ],
      isMobile: false,
      isShow: false,
      currentYear: new Date().getFullYear(),
      showPopSubMenu: false,
      isShowSubHeaderDrawer: false
    };
  },
  components: {
    Menu,
    Close,
    ArrowDownCircle,
    ArrowDown
  },
  props: {
    lang: {
      type: String,
      default: "id"
    },
    logo: {
      type: String,
      default: "https://static.desty.app/desty-design/desty-logo.svg"
    },
    subLogo: {
      type: String,
      default: "https://static.desty.app/desty-design/desty-page-logo.svg"
    },
    navKey: {
      type: String,
      default: "home"
    },
    navs: {
      type: Array,
      default: () => []
    },
    showSubHeader: {
      type: Boolean,
      default: true
    },
    isLogin: {
      type: Boolean,
      default: false
    },
    extraLinks: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleNav(key, hasSubMenu) {
      this.$emit("handleNav", key);
      if (hasSubMenu) {
        this.showPopSubMenu = !this.showPopSubMenu;
        if (this.isMobile)
          return;
        const navEle = document.querySelector(`#nav-item-${key}`);
        const popSubMenuEle = document.querySelector(`#pop-sub-menu-${key}`);
        const { height } = navEle.getBoundingClientRect();
        const IntHeight = parseInt(height);
        const offsetLeftGap = navEle.offsetLeft;
        const offsetTopGap = IntHeight + navEle.offsetTop + 10;
        popSubMenuEle.style.left = `${offsetLeftGap}px`;
        popSubMenuEle.style.top = `${offsetTopGap}px`;
      }
    },
    handleLang(key) {
      this.activeLangKey = key;
      this.$emit("handleLang", key);
    },
    handleAction(key) {
      this.$emit("handleAction", key);
    },
    handleExtraLinks() {
      this.isShowSubHeaderDrawer = !this.isShowSubHeaderDrawer;
    },
    handleShowMenuDialog() {
      this.isShow = true;
      document.body.style.overflow = "hidden";
    },
    handleCloseMenuDialog() {
      this.isShow = false;
      document.body.style.overflow = "auto";
    },
    handleCloseDrawer() {
      this.isShowSubHeaderDrawer = false;
    }
  },
  computed: {
    $t() {
      return (key) => {
        return getLanguage(this.lang, key);
      };
    },
    navList() {
      var _a;
      if (Array.isArray(this.navs) && ((_a = this.navs) == null ? void 0 : _a.length) > 0) {
        return this.navs;
      }
      return [
        {
          label: this.$t("header.home"),
          key: "home"
        },
        {
          label: this.$t("header.products"),
          key: "products",
          hasSubMenu: true
        },
        {
          label: this.$t("header.blog"),
          key: "blog"
        },
        {
          label: this.$t("header.helpcenter"),
          key: "helpcenter"
        }
      ];
    },
    rightActionBtns() {
      return [
        {
          label: this.$t("subHeader.signupBtn"),
          key: "signup"
        },
        {
          label: this.$t("subHeader.loginBtn"),
          key: "login"
        }
      ];
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler(newLang) {
        this.activeLangKey = newLang;
      }
    }
  },
  mounted() {
    this.destroyResizeScreen = resizeScreen(
      () => {
        this.isMobile = true;
      },
      () => {
        this.isMobile = false;
      }
    );
    if (this.showSubHeader) {
      this.destoryWatchScroll = watchScroll(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        const gap = this.isMobile ? 63 : 100;
        if (scrollTop >= gap) {
          this.subHeaderFixed = true;
        } else {
          this.subHeaderFixed = false;
        }
      });
    }
    if (!this.isMobile) {
      this.destoryClick = outsideClick(
        [".nav-item-sub-menu-v1", ".pop-sub-menu"],
        () => {
          this.showPopSubMenu = false;
        }
      );
    }
  },
  beforeDestroy() {
    if (this.destroyResizeScreen)
      this.destroyResizeScreen();
    if (this.destoryWatchScroll)
      this.destoryWatchScroll();
    if (this.destoryClick)
      this.destoryClick();
  }
};
const __cssModules$h = {};
var __component__$h = /* @__PURE__ */ normalizeComponent(
  __vue2_script$h,
  render$h,
  staticRenderFns$h,
  false,
  __vue2_injectStyles$h,
  "fa6a66b8",
  null,
  null
);
function __vue2_injectStyles$h(context) {
  for (let o in __cssModules$h) {
    this[o] = __cssModules$h[o];
  }
}
var DestyHeader = /* @__PURE__ */ function() {
  return __component__$h.exports;
}();
var render$g = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "desty-header-v2" }, [_c("img", { staticClass: "header-logo", attrs: { "src": _vm.logo, "alt": "desty design" }, on: { "click": function($event) {
    return _vm.handleNav("mainLogo");
  } } }), _vm.isMobile ? [_c("div", { staticClass: "language-box" }, [_vm._l(_vm.langs, function(item) {
    return _c("span", { key: item.key, class: ["lang-item", { "active-lang-item": _vm.activeLangKey === item.key }], on: { "click": function($event) {
      return _vm.handleLang(item.key);
    } } }, [_vm._v(_vm._s(item.label))]);
  }), _c("Menu", { staticClass: "menu-icon", nativeOn: { "click": function($event) {
    return _vm.handleShowMenuDialog.apply(null, arguments);
  } } })], 2)] : [_c("nav", { staticClass: "nav", attrs: { "id": "header-nav-v2" } }, _vm._l(_vm.navList, function(item) {
    return _c("span", { key: item.key, class: ["nav-item", { "nav-item-sub-menu-v2": item.hasSubMenu }], attrs: { "id": "nav-item-" + item.key }, on: { "click": function($event) {
      return _vm.handleNav(item.key, item.hasSubMenu);
    } } }, [_c("div", { class: ["nav-text", { "active-nav-text": _vm.navKey === item.key }] }, [_vm._v(" " + _vm._s(item.label) + " ")]), _c("div", { directives: [{ name: "show", rawName: "v-show", value: item.hasSubMenu && _vm.showPopSubMenu, expression: "item.hasSubMenu && showPopSubMenu" }], staticClass: "pop-sub-menu", attrs: { "id": "pop-sub-menu-" + item.key }, on: { "click": function($event) {
      $event.preventDefault();
      $event.stopPropagation();
      _vm.showPopSubMenu = !_vm.showPopSubMenu;
    } } }, [_vm._t("sub-menu-" + item.key + "-content", function() {
      return [_vm._v(" sub-menu-" + _vm._s(item.key) + "-content ")];
    })], 2), item.hasSubMenu ? _c("ArrowDownCircle") : _vm._e()], 1);
  }), 0), _vm._t("extra-content", function() {
    return [_c("div", { staticClass: "btn-login", on: { "click": function($event) {
      return _vm.handleNav("login");
    } } }, [_vm._v(_vm._s(_vm.$t("subHeader.loginBtn")))])];
  })], _vm.isMobile ? _c("div", { class: ["mobile-menu-dialog", { "mobile-menu-dialog-show": _vm.isShow }] }, [_c("header", { staticClass: "header" }, [_c("img", { staticClass: "mobile-header-logo", attrs: { "src": _vm.logo, "alt": "desty-logo" }, on: { "click": function($event) {
    return _vm.handleNav("mainLogo");
  } } }), _c("div", { staticClass: "mobile-language-box" }, [_vm._l(_vm.langs, function(item) {
    return _c("span", { key: item.key, class: ["mobile-lang-item", { "mobile-active-lang-item": _vm.activeLangKey === item.key }], on: { "click": function($event) {
      return _vm.handleLang(item.key);
    } } }, [_vm._v(_vm._s(item.label))]);
  }), _c("Close", { nativeOn: { "click": function($event) {
    return _vm.handleCloseMenuDialog.apply(null, arguments);
  } } })], 2)]), _c("div", { staticClass: "mobile-nav" }, _vm._l(_vm.navList, function(item) {
    return _c("div", { key: item.key, staticClass: "mobile-nav-item", on: { "click": function($event) {
      return _vm.handleNav(item.key, item.hasSubMenu);
    } } }, [_c("div", { class: ["nav-text", { "active-nav-text": _vm.navKey === item.key }] }, [_vm._v(" " + _vm._s(item.label) + " ")]), item.hasSubMenu ? _c("ArrowDownCircle") : _vm._e(), item.hasSubMenu && _vm.showPopSubMenu ? _c("div", { staticClass: "sub-menu-slot" }, [_vm._t("mobile-sub-menu-" + item.key + "-content", function() {
      return [_vm._v(" mobile-sub-menu-" + _vm._s(item.key) + "-content ")];
    })], 2) : _vm._e()], 1);
  }), 0), _c("footer", { staticClass: "footer" }, [_vm._t("menu-dialog-footer-extra-content"), _vm._v(" Copyright \xA9 " + _vm._s(_vm.currentYear) + " desty. All rights reserved. ")], 2)]) : _vm._e()], 2);
};
var staticRenderFns$g = [];
var index_vue_vue_type_style_index_0_scoped_true_lang$d = "";
const __vue2_script$g = {
  name: "DestyHeaderV2",
  data() {
    return {
      isMobile: false,
      showPopSubMenu: false,
      langs: [{
        label: "EN",
        key: "en"
      }, {
        label: "ID",
        key: "id"
      }],
      activeLangKey: "id",
      isShow: false,
      currentYear: new Date().getFullYear()
    };
  },
  components: {
    Menu,
    ArrowDownCircle,
    Close
  },
  props: {
    lang: {
      type: String,
      default: "id"
    },
    logo: {
      type: String,
      default: "https://static.desty.app/desty-design/desty-logo.svg"
    },
    navs: {
      type: Array,
      default: () => []
    },
    navKey: {
      type: String,
      default: "home"
    }
  },
  computed: {
    $t() {
      return (key) => {
        return getLanguage(this.lang, key);
      };
    },
    navList() {
      var _a;
      if (Array.isArray(this.navs) && ((_a = this.navs) == null ? void 0 : _a.length) > 0) {
        return this.navs;
      }
      return [{
        label: this.$t("header.home"),
        key: "home"
      }, {
        label: this.$t("header.products"),
        key: "products",
        hasSubMenu: true
      }, {
        label: this.$t("header.blog"),
        key: "blog"
      }, {
        label: this.$t("header.helpcenter"),
        key: "helpcenter"
      }];
    }
  },
  methods: {
    handleNav(key, hasSubMenu) {
      this.$emit("handleNav", key);
      if (hasSubMenu) {
        this.showPopSubMenu = !this.showPopSubMenu;
        if (this.isMobile)
          return;
        const navEle = document.querySelector(`#nav-item-${key}`);
        const popSubMenuEle = document.querySelector(`#pop-sub-menu-${key}`);
        const { height } = navEle.getBoundingClientRect();
        const IntHeight = parseInt(height);
        const offsetLeftGap = navEle.offsetLeft;
        const offsetTopGap = IntHeight + navEle.offsetTop + 10;
        popSubMenuEle.style.left = `${offsetLeftGap}px`;
        popSubMenuEle.style.top = `${offsetTopGap}px`;
      }
    },
    handleLang(key) {
      this.activeLangKey = key;
      this.$emit("handleLang", key);
    },
    handleShowMenuDialog() {
      this.isShow = true;
      document.body.style.overflow = "hidden";
    },
    handleCloseMenuDialog() {
      this.isShow = false;
      document.body.style.overflow = "auto";
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler(newLang) {
        this.activeLangKey = newLang;
      }
    }
  },
  mounted() {
    this.destroyResizeScreen = resizeScreen(() => {
      this.isMobile = true;
    }, () => {
      this.isMobile = false;
    });
    this.destorySubMenu = resizeScreen(() => {
      this.showPopSubMenu = false;
    }, () => {
      this.showPopSubMenu = false;
    });
    if (!this.isMobile) {
      this.destoryClick = outsideClick(
        [".nav-item-sub-menu-v2", ".pop-sub-menu"],
        () => {
          this.showPopSubMenu = false;
        }
      );
    }
  },
  beforeDestroy() {
    if (this.destroyResizeScreen)
      this.destroyResizeScreen();
    if (this.destorySubMenu)
      this.destorySubMenu();
    if (this.destoryClick)
      this.destoryClick();
  }
};
const __cssModules$g = {};
var __component__$g = /* @__PURE__ */ normalizeComponent(
  __vue2_script$g,
  render$g,
  staticRenderFns$g,
  false,
  __vue2_injectStyles$g,
  "4406dbce",
  null,
  null
);
function __vue2_injectStyles$g(context) {
  for (let o in __cssModules$g) {
    this[o] = __cssModules$g[o];
  }
}
var DestyHeaderV2 = /* @__PURE__ */ function() {
  return __component__$g.exports;
}();
var render$f = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "icons-box" }, [_c("svg", { staticClass: "icon icon-instagram", attrs: { "width": "19", "height": "19", "viewBox": "0 0 19 19", "xmlns": "http://www.w3.org/2000/svg" }, on: { "click": function($event) {
    return _vm.handleIcon("instagram");
  } } }, [_c("path", { attrs: { "d": "M11.5206 9.44283C11.5206 10.4091 10.7374 11.1923 9.77114 11.1923C8.80491 11.1923 8.02167 10.4091 8.02167 9.44283C8.02167 8.4766 8.80491 7.69336 9.77114 7.69336C10.7374 7.69336 11.5206 8.4766 11.5206 9.44283Z" } }), _c("path", { attrs: { "d": "M13.8624 6.34701C13.7783 6.11912 13.6441 5.91285 13.4698 5.74354C13.3005 5.56921 13.0944 5.43504 12.8663 5.35094C12.6814 5.27912 12.4036 5.19362 11.8919 5.17033C11.3383 5.14509 11.1724 5.13965 9.77102 5.13965C8.36952 5.13965 8.20356 5.14495 7.65016 5.17019C7.13845 5.19362 6.8605 5.27912 6.6757 5.35094C6.44767 5.43504 6.2414 5.56921 6.07223 5.74354C5.8979 5.91285 5.76373 6.11898 5.67949 6.34701C5.60767 6.53194 5.52217 6.8099 5.49888 7.3216C5.47364 7.87501 5.4682 8.04097 5.4682 9.44247C5.4682 10.8438 5.47364 11.0098 5.49888 11.5633C5.52217 12.075 5.60767 12.3529 5.67949 12.5378C5.76373 12.7658 5.89776 12.972 6.07209 13.1413C6.2414 13.3156 6.44754 13.4498 6.67556 13.5339C6.8605 13.6058 7.13845 13.6913 7.65016 13.7146C8.20356 13.7399 8.36938 13.7452 9.77088 13.7452C11.1725 13.7452 11.3385 13.7399 11.8918 13.7146C12.4035 13.6913 12.6814 13.6058 12.8663 13.5339C13.3241 13.3573 13.6859 12.9955 13.8624 12.5378C13.9342 12.3529 14.0197 12.075 14.0432 11.5633C14.0684 11.0098 14.0737 10.8438 14.0737 9.44247C14.0737 8.04097 14.0684 7.87501 14.0432 7.3216C14.0199 6.8099 13.9344 6.53194 13.8624 6.34701ZM9.77102 12.1374C8.2825 12.1374 7.07583 10.9309 7.07583 9.44233C7.07583 7.9538 8.2825 6.74728 9.77102 6.74728C11.2594 6.74728 12.4661 7.9538 12.4661 9.44233C12.4661 10.9309 11.2594 12.1374 9.77102 12.1374ZM12.5726 7.27056C12.2248 7.27056 11.9428 6.98856 11.9428 6.64073C11.9428 6.2929 12.2248 6.0109 12.5726 6.0109C12.9205 6.0109 13.2025 6.2929 13.2025 6.64073C13.2023 6.98856 12.9205 7.27056 12.5726 7.27056Z" } }), _c("path", { attrs: { "d": "M9.77137 0.302734C4.72421 0.302734 0.631287 4.39566 0.631287 9.44282C0.631287 14.49 4.72421 18.5829 9.77137 18.5829C14.8185 18.5829 18.9114 14.49 18.9114 9.44282C18.9114 4.39566 14.8185 0.302734 9.77137 0.302734ZM14.9881 11.6066C14.9627 12.1653 14.8739 12.5468 14.7442 12.8807C14.4715 13.5857 13.9142 14.143 13.2092 14.4156C12.8755 14.5453 12.4939 14.634 11.9353 14.6596C11.3757 14.6851 11.1969 14.6912 9.77151 14.6912C8.34602 14.6912 8.16736 14.6851 7.60754 14.6596C7.04898 14.634 6.6674 14.5453 6.33366 14.4156C5.98332 14.2838 5.66617 14.0773 5.40397 13.8102C5.13703 13.5482 4.93048 13.2309 4.79869 12.8807C4.66898 12.5469 4.58014 12.1653 4.55476 11.6068C4.52896 11.047 4.52296 10.8682 4.52296 9.44282C4.52296 8.01747 4.52896 7.83867 4.55462 7.27899C4.58 6.72029 4.6687 6.33885 4.79841 6.00496C4.9302 5.65476 5.13689 5.33748 5.40397 5.07542C5.66603 4.80834 5.98332 4.60179 6.33352 4.47C6.6674 4.34029 7.04884 4.25159 7.60754 4.22607C8.16722 4.20055 8.34602 4.19441 9.77137 4.19441C11.1967 4.19441 11.3755 4.20055 11.9352 4.22621C12.4939 4.25159 12.8753 4.34029 13.2092 4.46986C13.5594 4.60165 13.8767 4.80834 14.1389 5.07542C14.4058 5.33762 14.6125 5.65476 14.7442 6.00496C14.874 6.33885 14.9627 6.72029 14.9883 7.27899C15.0138 7.83867 15.0198 8.01747 15.0198 9.44282C15.0198 10.8682 15.0138 11.047 14.9881 11.6066Z" } })]), _c("svg", { staticClass: "icon icon-facebook", attrs: { "width": "19", "height": "19", "viewBox": "0 0 19 19", "xmlns": "http://www.w3.org/2000/svg" }, on: { "click": function($event) {
    return _vm.handleIcon("facebook");
  } } }, [_c("path", { attrs: { "d": "M3.83465 18.4219C3.72548 18.4574 3.61592 18.4902 3.50595 18.5201C3.61592 18.4902 3.72548 18.4574 3.83465 18.4219Z" } }), _c("path", { attrs: { "d": "M3.88947 18.1201C3.85282 18.1393 3.81616 18.1569 3.77951 18.1748C3.81616 18.1569 3.85282 18.1393 3.88947 18.1201Z" } }), _c("path", { attrs: { "d": "M3.17727 18.4326C3.06827 18.4614 2.95859 18.4869 2.84857 18.5085C2.95859 18.4869 3.06827 18.4614 3.17727 18.4326Z" } }), _c("path", { attrs: { "d": "M3.57065 18.4473C3.52754 18.4636 3.48414 18.4788 3.44089 18.4932C3.48414 18.4788 3.52754 18.4636 3.57065 18.4473Z" } }), _c("path", { attrs: { "d": "M4.21489 18.1182C4.1816 18.1377 4.14816 18.1573 4.11472 18.1761C4.14816 18.1573 4.1816 18.1377 4.21489 18.1182Z" } }), _c("path", { attrs: { "d": "M4.88143 18.1162C4.84804 18.1374 4.81464 18.1573 4.78125 18.1781C4.81464 18.1573 4.84804 18.1374 4.88143 18.1162Z" } }), _c("path", { attrs: { "d": "M4.54946 18.1152C4.51617 18.1364 4.48273 18.158 4.44928 18.1783C4.48273 18.158 4.51617 18.1368 4.54946 18.1152Z" } }), _c("path", { attrs: { "d": "M4.21785 18.1182C4.18467 18.1381 4.15117 18.1569 4.11768 18.1761C4.15117 18.1569 4.18467 18.1381 4.21785 18.1182Z" } }), _c("path", { attrs: { "d": "M2.92137 18.4551C2.87292 18.4667 2.82447 18.477 2.77588 18.4862C2.82447 18.477 2.87292 18.4667 2.92137 18.4551Z" } }), _c("path", { attrs: { "d": "M18.4071 9.36994C18.4071 4.36303 14.2858 0.302734 9.20355 0.302734C4.12135 0.302734 0 4.36303 0 9.36994C0 14.3769 4.12135 18.4371 9.20355 18.4371C9.25762 18.4371 9.31141 18.436 9.36534 18.4351V11.3766H7.38801V9.10638H9.36534V7.43574C9.36534 5.49823 10.5659 4.44369 12.3202 4.44369C13.1603 4.44369 13.8824 4.50539 14.0929 4.53293V6.55788H12.8832C11.9288 6.55788 11.744 7.00477 11.744 7.66043V9.10638H14.0261L13.7287 11.3766H11.744V18.0868C15.591 17.0003 18.4071 13.5087 18.4071 9.36994Z" } }), _c("path", { attrs: { "d": "M2.84857 18.4502C2.73943 18.4678 2.62981 18.4817 2.51987 18.4909C2.62981 18.4817 2.73943 18.4678 2.84857 18.4502Z" } }), _c("path", { attrs: { "d": "M2.59615 18.4658C2.54532 18.4706 2.49434 18.4742 2.44336 18.4766C2.49434 18.4742 2.54532 18.4706 2.59615 18.4658Z" } })]), _c("svg", { staticClass: "icon icon-linkedin", attrs: { "width": "19", "height": "19", "viewBox": "0 0 19 19", "xmlns": "http://www.w3.org/2000/svg" }, on: { "click": function($event) {
    return _vm.handleIcon("linkedin");
  } } }, [_c("path", { attrs: { "d": "M9.3808 0.302734C4.29859 0.302734 0.177246 4.42408 0.177246 9.50629C0.177246 14.5885 4.29859 18.7098 9.3808 18.7098C14.463 18.7098 18.5844 14.5885 18.5844 9.50629C18.5844 4.42408 14.463 0.302734 9.3808 0.302734ZM6.70635 14.2159H4.46487V7.47237H6.70635V14.2159ZM5.58568 6.55153H5.57108C4.81891 6.55153 4.33244 6.03375 4.33244 5.38663C4.33244 4.7249 4.83379 4.22144 5.60057 4.22144C6.36734 4.22144 6.83921 4.7249 6.85381 5.38663C6.85381 6.03375 6.36734 6.55153 5.58568 6.55153ZM14.7887 14.2159H12.5475V10.6083C12.5475 9.70163 12.2229 9.0833 11.4119 9.0833C10.7927 9.0833 10.424 9.50039 10.2619 9.90302C10.2026 10.0471 10.1882 10.2485 10.1882 10.45V14.2159H7.94682C7.94682 14.2159 7.97617 8.10503 7.94682 7.47237H10.1882V8.42719C10.486 7.96768 11.019 7.3141 12.2082 7.3141C13.6829 7.3141 14.7887 8.2779 14.7887 10.3492V14.2159Z" } })]), _c("svg", { staticClass: "icon icon-youtube", attrs: { "width": "19", "height": "19", "viewBox": "0 0 19 19", "xmlns": "http://www.w3.org/2000/svg" }, on: { "click": function($event) {
    return _vm.handleIcon("youtube");
  } } }, [_c("path", { attrs: { "d": "M8.7215 11.1552L11.6946 9.44284L8.7215 7.73047V11.1552Z" } }), _c("path", { attrs: { "d": "M9.85981 0.302734C4.81265 0.302734 0.719727 4.39566 0.719727 9.44282C0.719727 14.49 4.81265 18.5829 9.85981 18.5829C14.907 18.5829 18.9999 14.49 18.9999 9.44282C18.9999 4.39566 14.907 0.302734 9.85981 0.302734ZM15.571 9.45216C15.571 9.45216 15.571 11.3058 15.3358 12.1997C15.204 12.6889 14.8183 13.0747 14.329 13.2063C13.4352 13.4416 9.85981 13.4416 9.85981 13.4416C9.85981 13.4416 6.29379 13.4416 5.3906 13.197C4.90135 13.0653 4.51559 12.6794 4.38379 12.1902C4.14851 11.3058 4.14851 9.44282 4.14851 9.44282C4.14851 9.44282 4.14851 7.5893 4.38379 6.69546C4.51545 6.20621 4.9107 5.81097 5.3906 5.67931C6.28444 5.44403 9.85981 5.44403 9.85981 5.44403C9.85981 5.44403 13.4352 5.44403 14.329 5.68865C14.8183 5.82031 15.204 6.20621 15.3358 6.69546C15.5804 7.5893 15.571 9.45216 15.571 9.45216Z" } })])]);
};
var staticRenderFns$f = [];
var index_vue_vue_type_style_index_0_scoped_true_lang$c = "";
const __vue2_script$f = {
  name: "Icons",
  methods: {
    handleIcon(key) {
      this.$emit("handleIcon", key);
    }
  }
};
const __cssModules$f = {};
var __component__$f = /* @__PURE__ */ normalizeComponent(
  __vue2_script$f,
  render$f,
  staticRenderFns$f,
  false,
  __vue2_injectStyles$f,
  "285dfa94",
  null,
  null
);
function __vue2_injectStyles$f(context) {
  for (let o in __cssModules$f) {
    this[o] = __cssModules$f[o];
  }
}
var Icons = /* @__PURE__ */ function() {
  return __component__$f.exports;
}();
const emialReg = /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/;
const footerMixin = {
  data() {
    return {
      emailValue: "",
      currentYear: new Date().getFullYear(),
      showDestySection: true,
      showCompanySection: true,
      showLangPop: false,
      activeLangKey: "id",
      emailError: false
    };
  },
  props: {
    logo: {
      type: String,
      default: "https://static.desty.app/desty-design/desty-footer-logo.svg"
    },
    lang: {
      type: String,
      default: "id"
    },
    navKey: {
      type: String,
      default: ""
    }
  },
  components: {
    ArrowDown,
    Icons
  },
  methods: {
    handleNav(key) {
      this.$emit("handleNav", key);
    },
    handleShowLangPop() {
      this.showLangPop = !this.showLangPop;
    },
    handleLang(key) {
      this.showLangPop = false;
      this.activeLangKey = key;
      this.$emit("handleLang", key);
    },
    handleSendEmail() {
      if (emialReg.test(this.emailValue)) {
        this.emailError = false;
        this.$emit("handleSendEmail", this.emailValue);
      } else {
        this.emailError = true;
      }
    },
    handleShowDestySection() {
      this.showDestySection = !this.showDestySection;
    },
    handleShowCompanySection() {
      this.showCompanySection = !this.showCompanySection;
    }
  },
  computed: {
    $t() {
      return (key) => {
        return getLanguage(this.lang, key);
      };
    },
    currentLang() {
      return this.activeLangKey === "en" ? "ENGLISH" : "INDONESIA";
    },
    destyList() {
      return [
        {
          label: this.$t("desty.omni"),
          key: "destyomni"
        },
        {
          label: this.$t("desty.page"),
          key: "destypage"
        },
        {
          label: this.$t("desty.store"),
          key: "destystore"
        },
        {
          label: this.$t("desty.chat"),
          key: "destychat"
        },
        {
          label: this.$t("desty.wholesale"),
          key: "destywholesale"
        }
      ];
    },
    companyList() {
      return [
        {
          label: this.$t("company.abountus"),
          key: "companyaboutus"
        },
        {
          label: this.$t("company.newsroom"),
          key: "companynewsroom"
        },
        {
          label: this.$t("company.investor"),
          key: "companyinvestor"
        },
        {
          label: this.$t("company.contactus"),
          key: "companycontactus"
        },
        {
          label: this.$t("company.career"),
          key: "companycareer"
        },
        {
          label: this.$t("company.blog"),
          key: "companyblog"
        }
      ];
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler(newLang) {
        this.activeLangKey = newLang;
      }
    }
  }
};
var render$e = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "desty-footer-pc" }, [_c("img", { staticClass: "header-logo", attrs: { "src": _vm.logo, "alt": "footer logo" }, on: { "click": function($event) {
    return _vm.handleNav("logo");
  } } }), _c("div", { staticClass: "middle-box" }, [_c("div", { staticClass: "left-content" }, [_c("div", { staticClass: "desty" }, [_c("h4", { staticClass: "title" }, [_vm._v(_vm._s(_vm.$t("footer.title1")))]), _c("ul", { staticClass: "ul-item" }, _vm._l(_vm.destyList, function(item) {
    return _c("li", { key: item.key, class: ["nomarl-ul-item", { "active-ul-item": item.key === _vm.navKey }], on: { "click": function($event) {
      return _vm.handleNav(item.key);
    } } }, [_vm._v(_vm._s(item.label))]);
  }), 0)]), _c("div", { staticClass: "company" }, [_c("h4", { staticClass: "title" }, [_vm._v(_vm._s(_vm.$t("footer.title2")))]), _c("ul", { staticClass: "ul-item" }, _vm._l(_vm.companyList, function(item) {
    return _c("li", { key: item.key, class: ["nomarl-ul-item", { "active-ul-item": item.key === _vm.navKey }], on: { "click": function($event) {
      return _vm.handleNav(item.key);
    } } }, [_vm._v(_vm._s(item.label))]);
  }), 0)]), _c("div", { staticClass: "followus" }, [_c("h4", { staticClass: "title" }, [_vm._v(_vm._s(_vm.$t("footer.title3")))]), _c("Icons", { on: { "handleIcon": _vm.handleNav } }), _vm._t("extra-content")], 2)]), _c("div", { staticClass: "subscribe" }, [_c("h4", { staticClass: "title" }, [_vm._v(_vm._s(_vm.$t("footer.title4")))]), _c("div", { staticClass: "text-desc" }, [_vm._v(_vm._s(_vm.$t("footer.subscribeDesc")))]), _c("div", { staticClass: "send-box" }, [_c("input", { directives: [{ name: "model", rawName: "v-model", value: _vm.emailValue, expression: "emailValue" }], staticClass: "input-box", attrs: { "placeholder": _vm.$t("footer.emailPlaceholderText") }, domProps: { "value": _vm.emailValue }, on: { "input": function($event) {
    if ($event.target.composing) {
      return;
    }
    _vm.emailValue = $event.target.value;
  } } }), _c("div", { staticClass: "send-btn", on: { "click": _vm.handleSendEmail } }, [_vm._v(_vm._s(_vm.$t("footer.emailBtn")))]), _vm.emailError ? _c("div", { staticClass: "error-text" }, [_vm._v(_vm._s(_vm.$t("footer.emailErrorText")))]) : _vm._e()])])]), _c("div", { staticClass: "bottom-box" }, [_c("div", { staticClass: "left-box" }, [_c("div", { staticClass: "lang-box" }, [_c("span", { staticClass: "current-lang" }, [_vm._v(_vm._s(_vm.currentLang))]), _c("ArrowDown", { attrs: { "forwadUp": _vm.showLangPop }, nativeOn: { "click": function($event) {
    return _vm.handleShowLangPop.apply(null, arguments);
  } } }), _vm.showLangPop ? _c("div", { staticClass: "pop-menu" }, [_c("span", { class: ["lang-item", { "active-lang-item": _vm.activeLangKey === "id" }], on: { "click": function($event) {
    return _vm.handleLang("id");
  } } }, [_vm._v("INDONESIA")]), _c("span", { class: ["lang-item", { "active-lang-item": _vm.activeLangKey === "en" }], on: { "click": function($event) {
    return _vm.handleLang("en");
  } } }, [_vm._v("ENGLISH")])]) : _vm._e()], 1), _c("div", { staticClass: "privacy", on: { "click": function($event) {
    return _vm.handleNav("privacy");
  } } }, [_vm._v(_vm._s(_vm.$t("footer.privacy")))]), _c("div", { staticClass: "terms", on: { "click": function($event) {
    return _vm.handleNav("terms");
  } } }, [_vm._v(_vm._s(_vm.$t("footer.terms")))])]), _c("div", { staticClass: "copy" }, [_vm._v("Copyright \xA9 " + _vm._s(_vm.currentYear) + " desty. All rights reserved.")])])]);
};
var staticRenderFns$e = [];
var index_vue_vue_type_style_index_0_scoped_true_lang$b = "";
const __vue2_script$e = {
  name: "DestyFooterPc",
  mixins: [footerMixin]
};
const __cssModules$e = {};
var __component__$e = /* @__PURE__ */ normalizeComponent(
  __vue2_script$e,
  render$e,
  staticRenderFns$e,
  false,
  __vue2_injectStyles$e,
  "6deaf556",
  null,
  null
);
function __vue2_injectStyles$e(context) {
  for (let o in __cssModules$e) {
    this[o] = __cssModules$e[o];
  }
}
var FooterPc = /* @__PURE__ */ function() {
  return __component__$e.exports;
}();
var render$d = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "desty-footer-mobile" }, [_c("img", { staticClass: "header-logo", attrs: { "src": _vm.logo, "alt": "footer desty logo" }, on: { "click": function($event) {
    return _vm.handleNav("logo");
  } } }), _c("div", { staticClass: "middle-box" }, [_c("h4", { staticClass: "title" }, [_vm._v(" " + _vm._s(_vm.$t("footer.title1")) + " "), _c("ArrowDown", { attrs: { "forwadUp": _vm.showDestySection }, nativeOn: { "click": function($event) {
    return _vm.handleShowDestySection.apply(null, arguments);
  } } })], 1), _vm.showDestySection ? _c("ul", { staticClass: "ul-item" }, _vm._l(_vm.destyList, function(item) {
    return _c("li", { key: item.key, class: ["nomarl-ul-item", { "active-ul-item": item.key === _vm.navKey }], on: { "click": function($event) {
      return _vm.handleNav(item.key);
    } } }, [_vm._v(_vm._s(item.label))]);
  }), 0) : _vm._e(), _c("h4", { staticClass: "title" }, [_vm._v(" " + _vm._s(_vm.$t("footer.title2")) + " "), _c("ArrowDown", { attrs: { "forwadUp": _vm.showCompanySection }, nativeOn: { "click": function($event) {
    return _vm.handleShowCompanySection.apply(null, arguments);
  } } })], 1), _vm.showCompanySection ? _c("ul", { staticClass: "ul-item" }, _vm._l(_vm.companyList, function(item) {
    return _c("li", { key: item.key, class: ["nomarl-ul-item", { "active-ul-item": item.key === _vm.navKey }], on: { "click": function($event) {
      return _vm.handleNav(item.key);
    } } }, [_vm._v(_vm._s(item.label))]);
  }), 0) : _vm._e(), _c("h4", { staticClass: "title" }, [_vm._v(" " + _vm._s(_vm.$t("footer.title3")) + " ")]), _c("Icons", { on: { "handleIcon": _vm.handleNav } }), _vm._t("extra-content"), _c("h4", { staticClass: "title" }, [_vm._v(" " + _vm._s(_vm.$t("footer.title4")) + " ")]), _c("div", { staticClass: "subscribe-box" }, [_c("div", { staticClass: "desc" }, [_vm._v(_vm._s(_vm.$t("footer.subscribeDesc")))]), _c("div", { staticClass: "email-box" }, [_c("input", { directives: [{ name: "model", rawName: "v-model", value: _vm.emailValue, expression: "emailValue" }], staticClass: "email-input", attrs: { "type": "email", "placeholder": _vm.$t("footer.emailPlaceholderText") }, domProps: { "value": _vm.emailValue }, on: { "input": function($event) {
    if ($event.target.composing) {
      return;
    }
    _vm.emailValue = $event.target.value;
  } } }), _c("button", { staticClass: "btn", on: { "click": _vm.handleSendEmail } }, [_vm._v(_vm._s(_vm.$t("footer.emailBtn")))])]), _vm.emailError ? _c("div", { staticClass: "error-text" }, [_vm._v(_vm._s(_vm.$t("footer.emailErrorText")))]) : _vm._e()])], 2), _c("div", { staticClass: "bottom-box" }, [_c("div", { staticClass: "lang-box" }, [_c("span", { staticClass: "current-lang" }, [_vm._v(_vm._s(_vm.currentLang))]), _c("ArrowDown", { attrs: { "forwadUp": _vm.showLangPop }, nativeOn: { "click": function($event) {
    return _vm.handleShowLangPop.apply(null, arguments);
  } } }), _vm.showLangPop ? _c("div", { staticClass: "pop-menu" }, [_c("span", { class: ["lang-item", { "active-lang-item": _vm.activeLangKey === "id" }], on: { "click": function($event) {
    return _vm.handleLang("id");
  } } }, [_vm._v("INDONESIA")]), _c("span", { class: ["lang-item", { "active-lang-item": _vm.activeLangKey === "en" }], on: { "click": function($event) {
    return _vm.handleLang("en");
  } } }, [_vm._v("ENGLISH")])]) : _vm._e()], 1), _c("div", { staticClass: "privacy-terms" }, [_c("span", { staticClass: "privacy", on: { "click": function($event) {
    return _vm.handleNav("privacy");
  } } }, [_vm._v(_vm._s(_vm.$t("footer.privacy")))]), _c("span", { staticClass: "terms", on: { "click": function($event) {
    return _vm.handleNav("terms");
  } } }, [_vm._v(_vm._s(_vm.$t("footer.terms")))])]), _c("div", { staticClass: "copy" }, [_vm._v("Copyright \xA9 " + _vm._s(_vm.currentYear) + " desty. "), _c("br"), _vm._v(" All rights reserved.")])])]);
};
var staticRenderFns$d = [];
var index_vue_vue_type_style_index_0_scoped_true_lang$a = "";
const __vue2_script$d = {
  name: "DestyFooterMobile",
  mixins: [footerMixin]
};
const __cssModules$d = {};
var __component__$d = /* @__PURE__ */ normalizeComponent(
  __vue2_script$d,
  render$d,
  staticRenderFns$d,
  false,
  __vue2_injectStyles$d,
  "2a9ecc34",
  null,
  null
);
function __vue2_injectStyles$d(context) {
  for (let o in __cssModules$d) {
    this[o] = __cssModules$d[o];
  }
}
var FooterMobile = /* @__PURE__ */ function() {
  return __component__$d.exports;
}();
var render$c = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "desty-footer" }, [_c(_vm.currentComponent, { tag: "component", attrs: { "logo": _vm.logo, "lang": _vm.lang, "navKey": _vm.navKey }, on: { "handleNav": _vm.handleNav, "handleLang": _vm.handleLang, "handleSendEmail": _vm.handleSendEmail }, scopedSlots: _vm._u([{ key: "extra-content", fn: function() {
    return [_vm._t("extra")];
  }, proxy: true }], null, true) })], 1);
};
var staticRenderFns$c = [];
var index_vue_vue_type_style_index_0_scoped_true_lang$9 = "";
const __vue2_script$c = {
  name: "DestyFooter",
  data() {
    return {
      isMobile: false,
      currentComponent: "FooterPc"
    };
  },
  components: {
    FooterPc,
    FooterMobile
  },
  props: {
    logo: {
      type: String,
      default: "https://static.desty.app/desty-design/desty-footer-logo.svg"
    },
    lang: {
      type: String,
      default: "id"
    },
    navKey: {
      type: String,
      default: ""
    }
  },
  methods: {
    handleNav(key) {
      this.$emit("handleNav", key);
    },
    handleLang(key) {
      this.$emit("handleLang", key);
    },
    handleSendEmail(val) {
      this.$emit("handleSendEmail", val);
    }
  },
  mounted() {
    this.destroyResizeScreen = resizeScreen(() => {
      this.isMobile = true;
      this.currentComponent = "FooterMobile";
    }, () => {
      this.isMobile = false;
      this.currentComponent = "FooterPc";
    }, 1048);
  },
  beforeDestroy() {
    if (this.destroyResizeScreen)
      this.destroyResizeScreen();
  }
};
const __cssModules$c = {};
var __component__$c = /* @__PURE__ */ normalizeComponent(
  __vue2_script$c,
  render$c,
  staticRenderFns$c,
  false,
  __vue2_injectStyles$c,
  "24b87dce",
  null,
  null
);
function __vue2_injectStyles$c(context) {
  for (let o in __cssModules$c) {
    this[o] = __cssModules$c[o];
  }
}
var DestyFooter = /* @__PURE__ */ function() {
  return __component__$c.exports;
}();
var render$b = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("transition", { attrs: { "name": _vm.animation ? "dialog-fade" : "" } }, [_vm.visible ? _c("div", { staticClass: "desty-dialog-wrapper", style: _vm.setModalStyle(), on: { "click": function($event) {
    if ($event.target !== $event.currentTarget) {
      return null;
    }
    return _vm.handleMaskClose.apply(null, arguments);
  } } }, [_c("div", { staticClass: "dialog", style: { width: _vm.width, "margin-top": _vm.top } }, [_vm.$slots.title || _vm.showClose ? _c("div", { staticClass: "header" }, [_vm._t("title", function() {
    return [_vm._v("\xA0")];
  }), _vm.showClose ? _c("Close", { nativeOn: { "click": function($event) {
    return _vm.handleClose.apply(null, arguments);
  } } }) : _vm._e()], 2) : _vm._e(), _c("div", { staticClass: "body" }, [_vm._t("content")], 2), _vm.$slots.footer ? _c("div", { staticClass: "footer" }, [_vm._t("footer")], 2) : _vm._e()])]) : _vm._e()]);
};
var staticRenderFns$b = [];
var index_vue_vue_type_style_index_0_scoped_true_lang$8 = "";
const __vue2_script$b = {
  name: "DestyDialog",
  components: {
    Close
  },
  props: {
    width: {
      type: String,
      default: "30%"
    },
    top: {
      type: String,
      default: "15vh"
    },
    visible: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: true
    },
    maskTop: {
      type: String,
      default: "0px"
    },
    animation: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleClose() {
      this.$emit("handleClose");
    },
    handleMaskClose() {
      this.$emit("handleMaskClose");
    },
    setModalStyle() {
      return {
        height: `calc(100% - ${this.maskTop})`,
        top: this.maskTop
      };
    }
  },
  mounted() {
    document.body.appendChild(this.$el);
  },
  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  watch: {
    visible(newVisible) {
      if (newVisible) {
        document.body.style.overflowY = "hidden";
      } else {
        document.body.style.overflowY = "auto";
      }
    }
  }
};
const __cssModules$b = {};
var __component__$b = /* @__PURE__ */ normalizeComponent(
  __vue2_script$b,
  render$b,
  staticRenderFns$b,
  false,
  __vue2_injectStyles$b,
  "3eabf6fa",
  null,
  null
);
function __vue2_injectStyles$b(context) {
  for (let o in __cssModules$b) {
    this[o] = __cssModules$b[o];
  }
}
var DestyDialog = /* @__PURE__ */ function() {
  return __component__$b.exports;
}();
var render$a = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "country-deny" }, [_c("img", { attrs: { "src": "https://static.desty.app/desty-store/philippines-img.png", "width": "270", "height": "224", "alt": "top-img" } }), _c("div", { staticClass: "text-box" }, [_c("div", { staticClass: "title" }, [_vm._v("Oops!")]), _c("div", { staticClass: "desc" }, [_vm._v(" Desty Store is not available yet in " + _vm._s(_vm.countryObj.country)), _c("img", { staticClass: "small", attrs: { "alt": "desty-design-img", "src": _vm.countryObj.logo } }), _vm._v("Stay tuned! ")]), _c("div", { staticClass: "btn", on: { "click": _vm.handleClick } }, [_vm._v("Back to Homepage")])])]);
};
var staticRenderFns$a = [];
var index_vue_vue_type_style_index_0_scoped_true_lang$7 = "";
const __vue2_script$a = {
  name: "DestyCountryDeny",
  props: {
    phone: {
      type: String,
      required: true
    }
  },
  computed: {
    countryObj() {
      var _a, _b;
      const telPredix = (_b = (_a = this.phone) == null ? void 0 : _a.slice) == null ? void 0 : _b.call(_a, 0, 3);
      switch (telPredix) {
        case "+63":
          return {
            country: "Philippines",
            logo: "https://static.desty.app/desty-design/phl-logo.svg"
          };
        case "+60":
          return {
            country: "Malaysia",
            logo: "https://static.desty.app/desty-design/my-logo.svg"
          };
        case "+66":
          return {
            country: "Thailand",
            logo: "https://static.desty.app/desty-design/th-logo.svg"
          };
        case "+84":
          return {
            country: "Vietnam",
            logo: "https://static.desty.app/desty-design/vn-logo.svg"
          };
        default:
          return {
            country: "Philippines",
            logo: "https://static.desty.app/desty-design/phl-logo.svg"
          };
      }
    }
  },
  methods: {
    handleClick() {
      this.$emit("handleBackHome");
    }
  }
};
const __cssModules$a = {};
var __component__$a = /* @__PURE__ */ normalizeComponent(
  __vue2_script$a,
  render$a,
  staticRenderFns$a,
  false,
  __vue2_injectStyles$a,
  "4f47b5d8",
  null,
  null
);
function __vue2_injectStyles$a(context) {
  for (let o in __cssModules$a) {
    this[o] = __cssModules$a[o];
  }
}
var DestyCountryDeny = /* @__PURE__ */ function() {
  return __component__$a.exports;
}();
var render$9 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("iframe", { ref: "iframeRef", staticStyle: { "display": "none" }, attrs: { "src": "https://common.desty.app", "frameborder": "0", "name": "desty-lang-iframe", "id": "desty-lang-iframe" }, on: { "load": _vm.loadOrigin } });
};
var staticRenderFns$9 = [];
var index_vue_vue_type_style_index_0_scoped_true_lang$6 = "";
const GET_TRANS_TYPE = "getDestyTransmitGlobalInfo";
const GET_SINGLE_TRANS_TYPE = "getDestyTransmitGlobalInfoSingleKey";
const SET_TRANS_TYPE = "setDestyTransmitGlobalInfo";
const DELETE_SINGLE_TRANS_TYPE = "deleteDestyTransmitGlobalInfoSingleKey";
const DELETE_ALL_TRANS_TYPE = "deleteDestyTransmitGlobalInfoAllKey";
const STORAGE_ENABLED_TRANS_TYPE = "storageEnabled";
const _GET_TRANS_TYPE = "_getDestyTransmitGlobalInfo";
const _GET_SINGLE_TRANS_TYPE = "_getDestyTransmitGlobalInfoSingleKey";
const _SET_TRANS_TYPE = "_setDestyTransmitGlobalInfo";
const _DELETE_SINGLE_TRANS_TYPE = "_deleteDestyTransmitGlobalInfoSingleKey";
const _DELETE_ALL_TRANS_TYPE = "_deleteDestyTransmitGlobalInfoAllKey";
const _STORAGE_ENABLED_TRANS_TYPE = "_storageEnabled";
const __vue2_script$9 = {
  name: "DestyTranslate",
  data() {
    return {
      getCommonTranslateResolve: null,
      getCommonTranslateBySingleKeyResolve: null,
      setCommonTranslateResolve: null,
      deleteCommonTranslateBySingleKeyResolve: null,
      deleteCommonTranslateByAllKeyResolve: null,
      storageEnabledResolve: null,
      loaded: false
    };
  },
  props: {
    isProduction: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    loadOrigin() {
      this.loaded = true;
    },
    loadIframeByFn(fn) {
      if (this.loaded) {
        if (typeof fn === "function")
          fn();
      } else {
        this.$refs.iframeRef.onload = () => {
          if (typeof fn === "function")
            fn();
        };
      }
    },
    isFunction(fn) {
      return typeof fn === "function";
    },
    formayDataKey(key) {
      if (this.isProduction)
        return key;
      return `informality_${key}`;
    },
    handleMsg(res = {}) {
      const { transType, destyCommonInfo, destyCommonInfoSingleKey, storageEnabled } = res.data || {};
      if (transType) {
        if (transType === _GET_TRANS_TYPE) {
          if (this.isFunction(this.getCommonTranslateResolve))
            this.getCommonTranslateResolve(destyCommonInfo);
        } else if (transType === _GET_SINGLE_TRANS_TYPE) {
          if (this.isFunction(this.getCommonTranslateBySingleKeyResolve))
            this.getCommonTranslateBySingleKeyResolve(destyCommonInfoSingleKey);
        } else if (transType === _SET_TRANS_TYPE) {
          if (this.isFunction(this.setCommonTranslateResolve))
            this.setCommonTranslateResolve(true);
        } else if (transType === _DELETE_SINGLE_TRANS_TYPE) {
          if (this.isFunction(this.deleteCommonTranslateBySingleKeyResolve))
            this.deleteCommonTranslateBySingleKeyResolve(true);
        } else if (transType === _DELETE_ALL_TRANS_TYPE) {
          if (this.isFunction(this.deleteCommonTranslateByAllKeyResolve))
            this.deleteCommonTranslateByAllKeyResolve(true);
        } else if (transType === _STORAGE_ENABLED_TRANS_TYPE) {
          if (this.isFunction(this.storageEnabledResolve))
            this.storageEnabledResolve(storageEnabled);
        }
      }
    },
    getCommonTranslate() {
      return new Promise((resolve, reject) => {
        this.loadIframeByFn(() => {
          this.getCommonTranslateResolve = resolve;
          const windowContext = this.$refs.iframeRef.contentWindow;
          if (windowContext) {
            windowContext.postMessage({ transType: GET_TRANS_TYPE }, "*");
            window.addEventListener("message", this.handleMsg, false);
          } else {
            reject("contentWindow not exist!");
          }
        });
      });
    },
    getCommonTranslateBySingleKey(key) {
      return new Promise((resolve, reject) => {
        this.loadIframeByFn(() => {
          this.getCommonTranslateBySingleKeyResolve = resolve;
          const windowContext = this.$refs.iframeRef.contentWindow;
          if (windowContext) {
            windowContext.postMessage({
              transType: GET_SINGLE_TRANS_TYPE,
              dataKey: this.formayDataKey(key)
            }, "*");
            window.addEventListener("message", this.handleMsg, false);
          } else {
            reject("contentWindow not exist!");
          }
        });
      });
    },
    setCommonTranslate(paramObj = {}) {
      return new Promise((resolve, reject) => {
        this.loadIframeByFn(() => {
          this.setCommonTranslateResolve = resolve;
          const windowContext = this.$refs.iframeRef.contentWindow;
          const { transType, dataKey, dataValue } = paramObj;
          if (windowContext) {
            windowContext.postMessage({
              transType: SET_TRANS_TYPE,
              dataKey: this.formayDataKey(dataKey),
              dataValue
            }, "*");
            window.addEventListener("message", this.handleMsg, false);
          } else {
            reject("contentWindow not exist!");
          }
        });
      });
    },
    deleteCommonTranslateBySingleKey(key) {
      return new Promise((resolve, reject) => {
        this.loadIframeByFn(() => {
          this.deleteCommonTranslateBySingleKeyResolve = resolve;
          const windowContext = this.$refs.iframeRef.contentWindow;
          if (windowContext) {
            windowContext.postMessage({
              transType: DELETE_SINGLE_TRANS_TYPE,
              dataKey: this.formayDataKey(key)
            }, "*");
            window.addEventListener("message", this.handleMsg, false);
          } else {
            reject("contentWindow not exist!");
          }
        });
      });
    },
    deleteCommonTranslateByAllKey() {
      return new Promise((resolve, reject) => {
        this.loadIframeByFn(() => {
          this.deleteCommonTranslateByAllKeyResolve = resolve;
          const windowContext = this.$refs.iframeRef.contentWindow;
          if (windowContext) {
            windowContext.postMessage({ transType: DELETE_ALL_TRANS_TYPE }, "*");
            window.addEventListener("message", this.handleMsg, false);
          } else {
            reject("contentWindow not exist!");
          }
        });
      });
    },
    isStorageEnabled() {
      return new Promise((resolve, reject) => {
        this.loadIframeByFn(() => {
          this.storageEnabledResolve = resolve;
          const windowContext = this.$refs.iframeRef.contentWindow;
          if (windowContext) {
            windowContext.postMessage({ transType: STORAGE_ENABLED_TRANS_TYPE }, "*");
            window.addEventListener("message", this.handleMsg, false);
          } else {
            reject("contentWindow not exist!");
          }
        });
      });
    }
  },
  beforeUnmount() {
    window.removeEventListener("message", this.handleMsg, false);
  }
};
const __cssModules$9 = {};
var __component__$9 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$9,
  render$9,
  staticRenderFns$9,
  false,
  __vue2_injectStyles$9,
  "4a55ce81",
  null,
  null
);
function __vue2_injectStyles$9(context) {
  for (let o in __cssModules$9) {
    this[o] = __cssModules$9[o];
  }
}
var DestyTranslate = /* @__PURE__ */ function() {
  return __component__$9.exports;
}();
var render$8 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("DestyTranslate", { ref: "destyTranslateRef", attrs: { "isProduction": _vm.isProduction } });
};
var staticRenderFns$8 = [];
var index_vue_vue_type_style_index_0_scoped_true_lang$5 = "";
const __vue2_script$8 = {
  name: "DestyExchangeToken",
  props: {
    isProduction: {
      type: Boolean,
      default: false
    },
    translateKey: {
      type: String,
      default: "common_token"
    },
    localTokenKey: {
      type: String,
      default: "token"
    },
    targetProduct: {
      type: String,
      default: "Store"
    }
  },
  components: {
    DestyTranslate
  },
  methods: {
    getBaseUrl() {
      if (this.isProduction)
        return "https://www.desty.app";
      return "https://staging.desty.app";
    },
    formatLocalToken() {
      if (typeof this.localTokenKey === "string") {
        return lodash_get(localStorage, this.localTokenKey);
      } else if (Array.isArray(this.localTokenKey)) {
        const [mainKey, ...restKey] = this.localTokenKey;
        const mainKeyObj = JSON.parse(localStorage[mainKey]) || {};
        const resKeyStr = restKey.join(".");
        return lodash_get(mainKeyObj, resKeyStr);
      }
    },
    async getToken() {
      var _a, _b, _c;
      try {
        const currDestyTranslateRef = this.$refs.destyTranslateRef;
        const storageEnabled = await currDestyTranslateRef.isStorageEnabled();
        let commonToken;
        if (storageEnabled) {
          const { token, source: source2 } = await currDestyTranslateRef.getCommonTranslateBySingleKey(this.translateKey) || {};
          commonToken = token;
          if (token) {
            if (!source2)
              throw new Error("source params is not exist!");
            const isIncludeBearer = (_c = (_b = (_a = token == null ? void 0 : token.toLocaleLowerCase) == null ? void 0 : _a.call(token)) == null ? void 0 : _b.includes) == null ? void 0 : _c.call(_b, "bearer");
            const res = await axios({
              url: "/api/user/sso/login",
              method: "post",
              baseURL: this.getBaseUrl(),
              headers: {
                authentication: isIncludeBearer ? token : `Bearer ${token}`,
                source: source2,
                target: this.targetProduct
              }
            });
            const { data: data2, code, msg } = (res == null ? void 0 : res.data) || {};
            if (code === "200") {
              commonToken = data2;
            } else {
              return Promise.reject(new Error(msg));
            }
          } else {
            commonToken = this.formatLocalToken();
          }
        } else {
          commonToken = this.formatLocalToken();
        }
        return commonToken;
      } catch (error) {
        console.log("get token", error);
      }
    }
  },
  mounted() {
    this.$emit("handleInit", this.$refs.destyTranslateRef);
  }
};
const __cssModules$8 = {};
var __component__$8 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$8,
  render$8,
  staticRenderFns$8,
  false,
  __vue2_injectStyles$8,
  "690ea639",
  null,
  null
);
function __vue2_injectStyles$8(context) {
  for (let o in __cssModules$8) {
    this[o] = __cssModules$8[o];
  }
}
var DestyExchangeToken = /* @__PURE__ */ function() {
  return __component__$8.exports;
}();
var render$7 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { attrs: { "width": "20", "height": "20", "viewBox": "0 0 20 20", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { attrs: { "d": "M8.3335 5.00016H5.00016C4.07969 5.00016 3.3335 5.74635 3.3335 6.66683V15.0002C3.3335 15.9206 4.07969 16.6668 5.00016 16.6668H13.3335C14.254 16.6668 15.0002 15.9206 15.0002 15.0002V11.6668M11.6668 3.3335H16.6668M16.6668 3.3335V8.3335M16.6668 3.3335L8.3335 11.6668", "stroke": "#31333A", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var staticRenderFns$7 = [];
const __vue2_script$7 = {
  name: "ShareIcon"
};
const __cssModules$7 = {};
var __component__$7 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$7,
  render$7,
  staticRenderFns$7,
  false,
  __vue2_injectStyles$7,
  null,
  null,
  null
);
function __vue2_injectStyles$7(context) {
  for (let o in __cssModules$7) {
    this[o] = __cssModules$7[o];
  }
}
var ShareIcon = /* @__PURE__ */ function() {
  return __component__$7.exports;
}();
var render$6 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  _vm._self._c || _h;
  return _vm._m(0);
};
var staticRenderFns$6 = [function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "loading" }, [_c("img", { staticClass: "loading-icon", attrs: { "src": "https://static.desty.app/desty-market/loading.png?x-oss-process=style/img-webp", "alt": "desty market" } })]);
}];
var index_vue_vue_type_style_index_0_scoped_true_lang$4 = "";
const __vue2_script$6 = {
  name: "Loading",
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  }
};
const __cssModules$6 = {};
var __component__$6 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$6,
  render$6,
  staticRenderFns$6,
  false,
  __vue2_injectStyles$6,
  "32c963f8",
  null,
  null
);
function __vue2_injectStyles$6(context) {
  for (let o in __cssModules$6) {
    this[o] = __cssModules$6[o];
  }
}
var Loading = /* @__PURE__ */ function() {
  return __component__$6.exports;
}();
var render$5 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "desty-apps-recommend-dialog" }, [_c("DestyDialog", { staticClass: "apps-recommend-dialog", attrs: { "visible": _vm.visible }, on: { "handleClose": _vm.handleCloseAction }, scopedSlots: _vm._u([{ key: "title", fn: function() {
    return [_c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.$t("appRecommend.toolsTitle")))])];
  }, proxy: true }, { key: "content", fn: function() {
    return [_c("div", { staticClass: "content", attrs: { "id": "market-dialog-content-box" } }, [_c("h1", { staticClass: "build-title" }, [_vm._v(_vm._s(_vm.$t("appRecommend.buildTitle")))]), _c("div", { staticClass: "apps-outer" }, [_vm.buildLoading ? _c("Loading", { attrs: { "loading": _vm.buildLoading } }) : _c("div", { staticClass: "apps" }, _vm._l(_vm.apps, function(app) {
      return _c("div", { key: app.appId, class: ["app-item", { "app-item-less4": _vm.apps.length < 4 }], on: { "click": function($event) {
        return _vm.handleDetail(app.detailUrl);
      } } }, [_c("div", { staticClass: "top" }, [_c("img", { staticClass: "app-logo", attrs: { "src": app.icon, "alt": "desty" } }), _c("h1", { staticClass: "app-title" }, [_vm._v(_vm._s(app.appName))]), _c("div", { staticClass: "app-desc" }, [_vm._v(" " + _vm._s(_vm.descShort(app.titleIndonesia, app.title)) + " ")])]), _c("div", { staticClass: "tags" }, _vm._l(app.tags, function(tag, tagIndex) {
        return _c("span", { key: tagIndex, staticClass: "tag-item" }, [_vm._v(" " + _vm._s(tag) + " ")]);
      }), 0)]);
    }), 0)], 1), _c("h1", { staticClass: "needs-title" }, [_vm._v(_vm._s(_vm.$t("appRecommend.needTitle")))]), _c("div", { staticClass: "extension-table-out" }, [_c("div", { staticClass: "extension-table" }, _vm._l(_vm.categoryList, function(item) {
      return _c("div", { key: item.code, class: [
        "extension-table-item",
        { "extension-table-active": item.code == _vm.activeNavKey }
      ], on: { "click": function($event) {
        return _vm.handleNavKey(item.code);
      } } }, [_c("div", [_vm._v(_vm._s(item.code === "" ? _vm.$t(item.name) : item.name))])]);
    }), 0)]), _c("div", { staticClass: "needs" }, [_c("Loading", { directives: [{ name: "show", rawName: "v-show", value: _vm.needLoading, expression: "needLoading" }], staticClass: "need-loading", attrs: { "loading": _vm.needLoading } }), _vm._l(_vm.needs, function(need) {
      return _c("div", { key: need.appId, staticClass: "need-item", on: { "click": function($event) {
        return _vm.handleDetail(need.detailUrl);
      } } }, [_c("img", { staticClass: "need-logo", attrs: { "src": need.icon, "alt": "desty" } }), _c("div", { staticClass: "right" }, [_c("div", [_c("h1", { staticClass: "need-title" }, [_c("div", { staticClass: "title" }, [_vm._v(_vm._s(need.appName))]), _vm.isShowStatus(need.actionType) ? _c("div", { class: [
        "status",
        { "status-disabled": need.actionType === "3" }
      ] }, [need.actionType === "99" ? _c("img", { staticClass: "check", attrs: { "src": "https://static.desty.app/desty-market/check.png?x-oss-process=style/img-webp", "alt": "desty market" } }) : _vm._e(), _vm._v(" " + _vm._s(_vm.statusText(need.actionType)) + " ")]) : _vm._e()]), _c("div", { staticClass: "need-desc" }, [_vm._v(" " + _vm._s(_vm.descShort(need.titleIndonesia, need.title)) + " ")])]), _c("div", { staticClass: "tags" }, _vm._l(need.tags, function(tag, tagIndex) {
        return _c("span", { key: tagIndex, staticClass: "tag-item" }, [_vm._v(" " + _vm._s(tag) + " ")]);
      }), 0)])]);
    })], 2), !!_vm.needs.length ? _c("div", { staticClass: "see-more-btn", on: { "click": _vm.handleFooter } }, [_vm._v(" " + _vm._s(_vm.$t("appRecommend.seeMore")) + " "), _c("ShareIcon")], 1) : _vm._e()])];
  }, proxy: true }]) })], 1);
};
var staticRenderFns$5 = [];
var index_vue_vue_type_style_index_0_scoped_true_lang$3 = "";
const __vue2_script$5 = {
  name: "DestyMarketAppsDialog",
  data() {
    return {
      apps: [],
      categoryList: [],
      needs: [],
      buildLoading: false,
      needLoading: false,
      activeNavKey: ""
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    lang: {
      type: String,
      default: "id"
    },
    isProduction: {
      type: Boolean,
      default: false
    },
    source: {
      type: String,
      required: true
    },
    token: {
      type: String,
      required: true
    }
  },
  components: {
    DestyDialog,
    ShareIcon,
    Loading
  },
  computed: {
    $t() {
      return (key) => {
        return getLanguage(this.lang, key);
      };
    }
  },
  methods: {
    isShowStatus(actionType) {
      return ["3", "99"].includes(actionType);
    },
    statusText(actionType) {
      if (actionType === "99")
        return "Added";
      if (actionType === "3")
        return "Coming soon";
      return "";
    },
    getBaseUrl() {
      if (this.isProduction)
        return "https://pulibic-gateway.desty.app";
      return "https://platform-gateway.desty.one";
    },
    formatTags(list = [], type) {
      list.forEach((item) => {
        item.tags = [];
        if (item.categoryL1Name)
          item.tags.push(item.categoryL1Name);
        if (item.categoryL2Name && type === "other")
          item.tags.push(item.categoryL2Name);
      });
    },
    getHeaderConfig() {
      var _a, _b, _c, _d;
      const isIncludeBearer = (_d = (_c = (_b = (_a = this.token) == null ? void 0 : _a.toLocaleLowerCase) == null ? void 0 : _b.call(_a)) == null ? void 0 : _c.includes) == null ? void 0 : _d.call(_c, "bearer");
      return {
        authentication: isIncludeBearer ? this.token : `Bearer ${this.token}`,
        token: this.token,
        source: this.source,
        target: "OMNI"
      };
    },
    async queryDesty() {
      this.buildLoading = true;
      try {
        const resAppList = await axios({
          url: "/platform/admin/appDetail/dashboard/getDesty",
          method: "post",
          data: { categoryId: "" },
          baseURL: this.getBaseUrl(),
          headers: this.getHeaderConfig()
        });
        const { code: appCode, data: appData } = (resAppList == null ? void 0 : resAppList.data) || {};
        if (appCode === 200) {
          const formatAppList = appData || [];
          this.formatTags(formatAppList);
          this.apps = formatAppList;
        } else {
          this.apps = [];
        }
      } catch (error) {
        console.log("queryDesty error: ", error);
      } finally {
        this.buildLoading = false;
      }
    },
    async queryOther(code) {
      this.needLoading = true;
      try {
        const resOtherList = await axios({
          url: "/platform/admin/appDetail/dashboard/getOtherApp",
          method: "post",
          baseURL: this.getBaseUrl(),
          headers: this.getHeaderConfig(),
          data: { categoryId: code }
        });
        const { code: otherCode, data: otherData } = (resOtherList == null ? void 0 : resOtherList.data) || {};
        if (otherCode === 200) {
          const formatOtherList = otherData || [];
          this.formatTags(formatOtherList, "other");
          this.needs = formatOtherList;
        } else {
          this.needs = [];
        }
      } catch (error) {
        console.log("queryOther error: ", error);
      } finally {
        this.needLoading = false;
      }
    },
    async getContent() {
      this.queryDesty();
      this.getCategory();
      this.queryOther("");
    },
    handleCloseAction() {
      this.$emit("handleClose");
    },
    handleFooter() {
      const url = this.isProduction ? "https://market.desty.app" : "https://staging-market.desty.app";
      window.open(url);
    },
    handleDetail(detailUrl) {
      if (detailUrl) {
        window.open(detailUrl);
      } else {
        throw new Error("handleDetail error: detailUrl is not exist!");
      }
    },
    descShort(descShortIndonesia, descShort) {
      return this.lang === "id" ? descShortIndonesia : descShort;
    },
    async handleNavKey(cateCode) {
      this.needLoading = true;
      try {
        this.activeNavKey = cateCode;
        await this.queryOther(cateCode);
      } catch (error) {
        console.log("handleNavKey error: ", error);
      } finally {
        this.needLoading = false;
      }
    },
    async getCategory() {
      try {
        const resCategory = await axios({
          url: "/platform/admin/appCategory/dashboard/get",
          method: "post",
          data: {},
          baseURL: this.getBaseUrl()
        });
        const { code, data: data2 } = (resCategory == null ? void 0 : resCategory.data) || {};
        if (code === 200) {
          const list = data2 || [];
          if (list.length) {
            list.unshift({ code: "", name: "appRecommend.allCategory" });
          }
          this.categoryList = list;
        } else {
          this.categoryList = [];
        }
        console.log(this.categoryList);
      } catch (error) {
        console.log("getCategory error: ", error);
      }
    }
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        if (!this.token)
          throw new Error("token is not exist!");
        if (!this.source)
          throw new Error("source is not exist!");
        this.$nextTick(() => {
          const marketDialogContentBoxEl = document.querySelector(
            "#market-dialog-content-box"
          );
          if (marketDialogContentBoxEl)
            marketDialogContentBoxEl.style.minHeight = `${window.innerHeight}px`;
        });
        this.getContent();
      }
    }
  }
};
const __cssModules$5 = {};
var __component__$5 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$5,
  render$5,
  staticRenderFns$5,
  false,
  __vue2_injectStyles$5,
  "f5e7d4dc",
  null,
  null
);
function __vue2_injectStyles$5(context) {
  for (let o in __cssModules$5) {
    this[o] = __cssModules$5[o];
  }
}
var DestyMarketAppsDialog = /* @__PURE__ */ function() {
  return __component__$5.exports;
}();
var render$4 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { attrs: { "width": "7", "height": "12", "viewBox": "0 0 7 12", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { attrs: { "d": "M1.33331 1.33238L5.99998 5.99904L1.33331 10.6657", "stroke": "#111827", "stroke-width": "1.5", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var staticRenderFns$4 = [];
const __vue2_script$4 = {
  name: "ArrowRight"
};
const __cssModules$4 = {};
var __component__$4 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$4,
  render$4,
  staticRenderFns$4,
  false,
  __vue2_injectStyles$4,
  null,
  null,
  null
);
function __vue2_injectStyles$4(context) {
  for (let o in __cssModules$4) {
    this[o] = __cssModules$4[o];
  }
}
var ArrowRight = /* @__PURE__ */ function() {
  return __component__$4.exports;
}();
var render$3 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "circle-loading" }, [_c("svg", { staticClass: "icon loading", attrs: { "t": "1691115383023", "viewBox": "0 0 1024 1024", "version": "1.1", "xmlns": "http://www.w3.org/2000/svg", "p-id": "5535" } }, [_c("path", { attrs: { "d": "M270.4 214.4C336 160 420 128 512 128c212 0 384 172 384 384h64c0-247.2-200.8-448-448-448-107.2 0-205.6 37.6-282.4 100l40.8 50.4z", "p-id": "5536", "fill": "#cdcdcd" } })])]);
};
var staticRenderFns$3 = [];
var index_vue_vue_type_style_index_0_scoped_true_lang$2 = "";
const __vue2_script$3 = {
  name: "CircleLoading"
};
const __cssModules$3 = {};
var __component__$3 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$3,
  render$3,
  staticRenderFns$3,
  false,
  __vue2_injectStyles$3,
  "931c7be6",
  null,
  null
);
function __vue2_injectStyles$3(context) {
  for (let o in __cssModules$3) {
    this[o] = __cssModules$3[o];
  }
}
var CircleLoading = /* @__PURE__ */ function() {
  return __component__$3.exports;
}();
var render$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "desty-market-app-select" }, [_c("div", { class: ["drop-down-box", { "drop-down-box-up": _vm.visible }], on: { "click": _vm.handleShowAction } }, [_c("div", { staticClass: "logo-box" }, [_vm.productFullLogo ? _c("img", { staticClass: "logo", attrs: { "src": _vm.productFullLogo, "alt": "product logo" } }) : _vm._e()]), _c("svg", { class: ["arrow-down", { "arrow-up": _vm.visible }], attrs: { "viewBox": "0 0 20 21", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { attrs: { "d": "M15.8333 7.83301L9.99996 13.6663L4.16663 7.83301", "stroke": "#111827", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" } })])]), _c("DestyDialog", { staticClass: "marketv2-modal", attrs: { "visible": _vm.visible, "maskTop": _vm.maskTopGap, "showClose": false, "animation": false, "top": _vm.topGap, "width": _vm.widthGap }, on: { "handleMaskClose": _vm.handleCloseAction }, scopedSlots: _vm._u([{ key: "content", fn: function() {
    return [_c("div", { staticClass: "content-box" }, [_vm._l(_vm.installLogos, function(item) {
      return _c("div", { key: item, staticClass: "content-box-item", on: { "click": function($event) {
        return _vm.handleClickItem(item);
      } } }, [_c("div", { staticClass: "left-logo" }, [_c("img", { staticClass: "logo-item", attrs: { "src": _vm.appInfo(item).logo, "alt": "logo-item" } }), _c("span", { staticClass: "logo-name" }, [_vm._v(_vm._s(_vm.appInfo(item).label))])]), _vm.isMobile ? _c("ArrowRight") : _vm._e()], 1);
    }), _vm.installLogosExist && _vm.uninstallLogosExist ? _c("div", { staticClass: "divide" }) : _vm._e(), _vm.uninstallLogosExist ? [_c("div", { staticClass: "uninstall-title" }, [_vm._v(" " + _vm._s(_vm.$t("marketSelectApp.addMoreText")) + " ")]), _vm._l(_vm.uninstallLogos, function(item) {
      return _c("div", { key: item, staticClass: "content-box-item", on: { "click": function($event) {
        return _vm.handleClickItem(item);
      } } }, [_c("div", { staticClass: "left-logo" }, [_c("img", { staticClass: "logo-item", attrs: { "src": _vm.appInfo(item).logo, "alt": "logo-item" } }), _c("span", { staticClass: "logo-name" }, [_vm._v(_vm._s(_vm.appInfo(item).label))])]), _vm.isMobile ? _c("ArrowRight") : _vm._e()], 1);
    })] : _vm._e(), _vm.loadng ? _c("CircleLoading", { staticClass: "market-circle-loading" }) : _vm._e()], 2)];
  }, proxy: true }]) })], 1);
};
var staticRenderFns$2 = [];
var index_vue_vue_type_style_index_0_scoped_true_lang$1 = "";
const __vue2_script$2 = {
  name: "DestyMarketAppSelect",
  data() {
    return {
      visible: false,
      installLogos: [],
      uninstallLogos: [],
      appsObj: {},
      isMobile: false,
      btnLoadng: false
    };
  },
  props: {
    lang: {
      type: String,
      default: "id"
    },
    product: {
      type: String,
      required: true
    },
    token: {
      type: String,
      required: true
    },
    env: {
      type: String,
      default: "staging"
    }
  },
  components: {
    DestyDialog,
    ArrowRight,
    CircleLoading
  },
  computed: {
    $t() {
      return (key) => {
        return getLanguage(this.lang, key);
      };
    },
    productFullLogo() {
      var _a;
      return (_a = this.appsObj[this.product] || {}) == null ? void 0 : _a.fullLogo;
    },
    maskTopGap() {
      return this.isMobile ? "0px" : "50px";
    },
    widthGap() {
      return this.isMobile ? "100%" : "180px";
    },
    topGap() {
      return this.isMobile ? "0px" : "3px";
    },
    installLogosExist() {
      var _a;
      return ((_a = this.installLogos) == null ? void 0 : _a.length) > 0;
    },
    uninstallLogosExist() {
      var _a;
      return ((_a = this.uninstallLogos) == null ? void 0 : _a.length) > 0;
    }
  },
  methods: {
    appInfo(itemKey) {
      return this.appsObj[itemKey] || {};
    },
    getBaseUrl() {
      if (this.env === "production")
        return "https://pulibic-gateway.desty.app";
      return "https://platform-gateway.desty.one";
    },
    async getApps() {
      try {
        this.loadng = true;
        const res = await axios({
          url: "/platform/admin/appProduct/getAppProductInstallDto",
          method: "get",
          baseURL: this.getBaseUrl(),
          headers: {
            token: this.token,
            app: this.product
          }
        });
        const { code, data: resData } = (res == null ? void 0 : res.data) || {};
        const { installLogos = [], uninstallLogos = [] } = resData || {};
        if (code === 200) {
          this.installLogos = installLogos;
          this.uninstallLogos = uninstallLogos;
        }
      } catch (error) {
        console.log("getApps error", error);
      } finally {
        this.loadng = false;
      }
    },
    async getLogos() {
      const res = await axios({
        url: "https://static.desty.app/desty-design/json/marketv2-logo.json",
        method: "get"
      });
      this.appsObj = (res == null ? void 0 : res.data) || {};
    },
    handleCloseAction() {
      this.visible = false;
      this.loadng = false;
    },
    handleShowAction() {
      this.visible = !this.visible;
      if (this.visible) {
        this.getApps();
      } else {
        this.loadng = false;
      }
    },
    handleClickItem(itemKey) {
      var _a;
      this.visible = false;
      const url = (_a = this.appsObj[itemKey]) == null ? void 0 : _a[this.env];
      if (url)
        window.open(url);
    },
    setIsMobile() {
      this.destroyResizeScreen = resizeScreen(
        () => {
          this.isMobile = true;
        },
        () => {
          this.isMobile = false;
        }
      );
    }
  },
  mounted() {
    this.getLogos();
    this.setIsMobile();
    this.destoryClick = outsideClick(
      [".desty-market-app-select", ".marketv2-modal"],
      () => {
        this.visible = false;
      }
    );
  },
  beforeDestroy() {
    if (this.destoryClick)
      this.destoryClick();
  }
};
const __cssModules$2 = {};
var __component__$2 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$2,
  render$2,
  staticRenderFns$2,
  false,
  __vue2_injectStyles$2,
  "3e40dd06",
  null,
  null
);
function __vue2_injectStyles$2(context) {
  for (let o in __cssModules$2) {
    this[o] = __cssModules$2[o];
  }
}
var DestyMarketAppSelect = /* @__PURE__ */ function() {
  return __component__$2.exports;
}();
var render$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { attrs: { "width": "20", "height": "20", "viewBox": "0 0 20 20", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("g", { attrs: { "clip-path": "url(#clip0_3140_95659)" } }, [_c("path", { attrs: { "d": "M15.6569 5.95962C16.1032 5.51331 16.1032 4.78969 15.6569 4.34338C15.2105 3.89706 14.4869 3.89706 14.0406 4.34338L10 8.38399L5.95939 4.34338C5.51308 3.89706 4.78946 3.89706 4.34315 4.34338C3.89683 4.78969 3.89683 5.51331 4.34315 5.95962L8.38376 10.0002L4.34315 14.0408C3.89683 14.4872 3.89683 15.2108 4.34315 15.6571C4.78946 16.1034 5.51308 16.1034 5.95939 15.6571L10 11.6165L14.0406 15.6571C14.4869 16.1034 15.2105 16.1034 15.6569 15.6571C16.1032 15.2108 16.1032 14.4872 15.6569 14.0408L11.6162 10.0002L15.6569 5.95962Z", "fill": "#374151" } })]), _c("defs", [_c("clipPath", { attrs: { "id": "clip0_3140_95659" } }, [_c("rect", { attrs: { "width": "20", "height": "20", "fill": "white" } })])])]);
};
var staticRenderFns$1 = [];
const __vue2_script$1 = {
  name: "CloseBold"
};
const __cssModules$1 = {};
var __component__$1 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$1,
  render$1,
  staticRenderFns$1,
  false,
  __vue2_injectStyles$1,
  null,
  null,
  null
);
function __vue2_injectStyles$1(context) {
  for (let o in __cssModules$1) {
    this[o] = __cssModules$1[o];
  }
}
var CloseBold = /* @__PURE__ */ function() {
  return __component__$1.exports;
}();
var render = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "desty-market-discovery" }, [_c("img", { staticClass: "cursor", attrs: { "src": _vm.iconImgs, "alt": "desty-discovery" }, on: { "click": _vm.handleShow } }), _c("transition", { attrs: { "name": "fadeX" } }, [_vm.isShow ? _c("div", { staticClass: "desty-discovery" }, [_c("div", { staticClass: "discovery" }, [_vm.isMobile ? _c("div", { staticClass: "mobileHeader" }, [_c("img", { staticClass: "back cursor", attrs: { "src": "https://static.desty.app/desty-design/discovery-right.svg", "alt": "discovery-right" }, on: { "click": _vm.handleClose } }), _c("span", { staticClass: "title cursor", on: { "click": _vm.handleClose } }, [_vm._v("Discovery")])]) : _c("div", { staticClass: "header centered" }, [_c("CloseBold", { staticClass: "close cursor", nativeOn: { "click": function($event) {
    return _vm.handleClose.apply(null, arguments);
  } } }), _c("span", { staticClass: "title" }, [_vm._v("Discovery")])], 1), _c("div", { staticClass: "content", attrs: { "id": "discovery-content-box" } }, [_c("div", { staticClass: "tool-box" }, [_vm.toolLoading || _vm.productImgs && _vm.productImgs.length > 0 ? _c("div", { staticClass: "tool" }, [_c("div", { staticClass: "tool-title centered" }, [_c("span", { staticClass: "title" }, [_vm._v(_vm._s(_vm.$t("discovery.toolTitle")))]), _c("div", { staticClass: "expandImg cursor", on: { "click": _vm.handleImgsShow } }, [!_vm.isMobile ? _c("img", { class: [{ "tool-arrow-up": _vm.isImgsShow }], attrs: { "src": "https://static.desty.app/desty-design/discovery-down.svg", "alt": "discovery-down" } }) : _vm._e()])]), _c("transition", { attrs: { "name": "fade" } }, [_vm.isImgsShow ? _c("div", { staticClass: "imgs-scroll" }, [_c("div", { staticClass: "imgs-content" }, _vm._l(_vm.productImgs, function(item) {
    return _c("img", { key: item.id, staticClass: "cursor", attrs: { "src": _vm.getProductImgSrc(item), "alt": "imgs" }, on: { "click": function($event) {
      return _vm.handleSkip(item.urlDashboard);
    } } });
  }), 0)]) : _vm._e()])], 1) : _vm._e(), _vm.toolLoading ? _c("CircleLoading", { staticClass: "market-tool-circle-loading" }) : _vm._e()], 1), _c("div", { staticClass: "calendar", class: { margin20: _vm.productImgs && _vm.productImgs.length > 0 } }, [_c("div", { staticClass: "calendar-title centered" }, [_c("div", { staticClass: "centered" }, [_c("div", { staticClass: "month" }, [_vm._v(" " + _vm._s(_vm.monthObj["month" + _vm.month]) + " ")]), _c("span", { staticClass: "title" }, [_vm._v(_vm._s(_vm.$t("discovery.calendarTitle")))])]), _c("div", { staticClass: "expandImg cursor", on: { "click": _vm.handleCollapseShow } }, [_c("img", { class: [{ "calendar-arrow-up": _vm.isCollapseShow }], attrs: { "src": "https://static.desty.app/desty-design/discovery-down.svg", "alt": "discovery-down" } })])]), _c("transition", { attrs: { "name": "fade" } }, [_vm.isCollapseShow ? _c("div", { staticClass: "collapse" }, [_vm.calendarList && _vm.calendarList.length > 0 ? _vm._l(_vm.calendarList, function(item, index2) {
    return _c("div", { key: index2, staticClass: "collapse-item" }, [_c("div", { staticClass: "date" }, [_c("span", { staticClass: "collapseDate" }, [_vm._v(_vm._s(_vm.handleDate("day", item.beginTimestamp)))]), _c("span", { staticClass: "collapseMonth startMonth" }, [_vm._v(_vm._s(_vm.handleDate("month", item.beginTimestamp))), _c("span", { staticClass: "shortDashedUp" }), _c("span", { staticClass: "dashed" }), _c("span", { staticClass: "shortDashedDown" })]), _c("span", { staticClass: "collapseDate endDate" }, [_vm._v(_vm._s(_vm.handleDate("day", item.endTimestamp)))]), _c("span", { staticClass: "collapseMonth" }, [_vm._v(_vm._s(_vm.handleDate("month", item.endTimestamp)))])]), _c("div", { staticClass: "collapse-item-right" }, _vm._l(item.recordEventList, function(items) {
      return _c("div", { key: items.id, staticClass: "collapseContent cursor", on: { "click": function($event) {
        return _vm.handleSkip(items.url);
      } } }, [_c("div", { staticClass: "eventTitle" }, [_vm._v(_vm._s(items.title))]), _c("div", { staticClass: "eventContent" }, [_c("span", { staticClass: "eventText" }, [_vm._v(_vm._s(_vm.lang === "en" ? items.descriptionEn : items.descriptionId))]), _c("img", { staticClass: "discovery-right", attrs: { "src": "https://static.desty.app/desty-design/discovery-right.svg", "alt": "discovery-right" } })])]);
    }), 0)]);
  }) : _c("div", { staticClass: "no-event" }, [_c("img", { attrs: { "src": "https://static.desty.app/desty-design/discovery-noevent.png", "alt": "no-event" } }), _c("p", [_vm._v("No event")])]), _vm.calendarLoading ? _c("CircleLoading", { staticClass: "market-calendar-circle-loading" }) : _vm._e()], 2) : _vm._e()])], 1)])])]) : _vm._e()])], 1);
};
var staticRenderFns = [];
var index_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script = {
  name: "DestyMarketDiscovery",
  components: {
    CircleLoading,
    CloseBold
  },
  props: {
    lang: {
      type: String,
      default: "id"
    },
    env: {
      type: String,
      default: "staging"
    },
    token: {
      type: String,
      required: true
    },
    product: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isShow: false,
      isImgsShow: true,
      isCollapseShow: true,
      isMobile: false,
      month: new Date().getMonth() + 1,
      monthObj: {
        month1: "Jan",
        month2: "Feb",
        month3: "Mar",
        month4: "Apr",
        month5: "May",
        month6: "Jun",
        month7: "Jul",
        month8: "Aug",
        month9: "Sep",
        month10: "Oct",
        month11: "Nov",
        month12: "Dec"
      },
      iconImgs: "",
      productImgs: [],
      calendarList: [],
      toolLoading: false,
      calendarLoading: false
    };
  },
  computed: {
    $t() {
      return (key) => {
        return getLanguage(this.lang, key);
      };
    }
  },
  methods: {
    async getIcon() {
      const res = await axios({
        url: "https://static.desty.app/desty-design/json/marketv2-logo.json",
        method: "get"
      });
      this.iconImgs = res == null ? void 0 : res.data[this.product].discoverIcon;
    },
    handleShow() {
      this.isShow = true;
      this.getAppResource();
      this.getCalendarEvent();
      this.$nextTick(() => {
        document.querySelector("#discovery-content-box").style.height = `${window.innerHeight - 50}px`;
      });
    },
    handleClose() {
      this.isShow = false;
    },
    handleImgsShow() {
      this.isImgsShow = !this.isImgsShow;
    },
    handleCollapseShow() {
      this.isCollapseShow = !this.isCollapseShow;
    },
    setIsMobile() {
      this.destroyResizeScreen = resizeScreen(
        () => {
          this.isMobile = true;
        },
        () => {
          this.isMobile = false;
        }
      );
    },
    getProductImgSrc(item) {
      if (this.isMobile) {
        return this.lang === "en" ? item.appPicEn : item.appPicId;
      } else {
        return this.lang === "en" ? item.picEn : item.picId;
      }
    },
    getBaseUrl() {
      if (this.env === "production")
        return "https://pulibic-gateway.desty.app";
      return "https://platform-gateway.desty.one";
    },
    handleSkip(url) {
      if (url)
        window.open(url);
    },
    handleDate(type, time) {
      var _a;
      const date = (_a = String(new Date(time))) == null ? void 0 : _a.split(" ");
      if (type === "month") {
        return date[1];
      } else {
        return date[2];
      }
    },
    async getAppResource() {
      this.toolLoading = true;
      try {
        const res = await axios({
          url: "/platform/admin/appProduct/getUsedConfigAppResource",
          method: "get",
          baseURL: this.getBaseUrl(),
          headers: {
            token: this.token,
            app: this.product
          }
        });
        const { data: data2 } = (res == null ? void 0 : res.data) || {};
        this.productImgs = data2 || [];
      } catch (error) {
        console.log("getAppResource Error", error);
      } finally {
        this.toolLoading = false;
      }
    },
    async getCalendarEvent() {
      this.calendarLoading = true;
      try {
        const res = await axios({
          url: "/platform/admin/recordEvent/searchList",
          method: "get",
          baseURL: this.getBaseUrl(),
          headers: {
            token: this.token
          },
          params: {
            isValid: true,
            app: this.product
          }
        });
        const { data: data2 } = (res == null ? void 0 : res.data) || {};
        this.calendarList = data2 || [];
      } catch (error) {
        console.log("getCalendarEvent Error", error);
      } finally {
        this.calendarLoading = false;
      }
    }
  },
  mounted() {
    this.getIcon();
    this.setIsMobile();
    this.destoryClick = outsideClick(
      [".desty-market-discovery", ".desty-discovery"],
      () => {
        this.isShow = false;
      }
    );
  },
  beforeDestroy() {
    this.destoryClick();
  }
};
const __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(
  __vue2_script,
  render,
  staticRenderFns,
  false,
  __vue2_injectStyles,
  "fcb1db74",
  null,
  null
);
function __vue2_injectStyles(context) {
  for (let o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var DestyMarketDiscovery = /* @__PURE__ */ function() {
  return __component__.exports;
}();
const map = /* @__PURE__ */ new WeakMap();
let observer;
if (typeof window !== "undefined") {
  observer = new ResizeObserver((entries) => {
    for (let i = 0; i < entries.length; i++) {
      const entry = entries[i], handlers = map.get(entry.target);
      if (handlers instanceof Set)
        handlers.forEach((e) => e(entry));
      else
        handlers(entry);
    }
  });
} else {
  observer = {
    observe() {
    },
    unobserve() {
    }
  };
}
var resizeobserver = {
  observer(el, handler) {
    const handlers = map.get(el);
    if (handlers instanceof Set)
      handlers.add(handler);
    else if (handlers)
      map.set(el, /* @__PURE__ */ new Set([handlers, handler]));
    else
      map.set(el, handler);
    observer.observe(el);
  },
  unobserve(el, handler) {
    if (handler) {
      const handlers = map.get(el);
      if (handlers instanceof Set) {
        handlers.delete(handler);
      }
    } else {
      map.delete(el);
      observer.unobserve(el);
    }
  }
};
var index$2 = "";
const camelizeRE = /-(\w)/g;
const camelize = (str) => {
  return str.replace(camelizeRE, (_, c) => c ? c.toUpperCase() : "");
};
const patchClass = (el, clazz, oldClazz) => {
  clazz = clazz.split(" "), oldClazz = oldClazz.split(" ");
  const addCls = clazz.filter((e) => !oldClazz.includes(e)), delCls = oldClazz.filter((e) => !clazz.includes(e));
  addCls.forEach((e) => e && el.classList.add(e));
  delCls.forEach((e) => e && el.classList.remove(e));
};
const getLoading = (value) => typeof value === "object" ? value.loading : value;
const getClass = (binding) => {
  const loading = getLoading(binding.value);
  if (!loading)
    return "";
  const animated = binding.modifiers.animated;
  const animatedCls = animated ? `${preCls}-animated` : "";
  return `${preCls} ${animatedCls}`;
};
const setup = (props) => {
  props = reactive(props);
  const createItem = (parent, target) => {
    const {
      el: parentEl,
      binding
    } = parent, {
      el
    } = target;
    el.classList.add(`${itemPreCls}-target`);
    const itemEl = document.createElement("div");
    itemEl.className = itemPreCls;
    target.resizeCb = () => {
      const parentRect = parentEl.getBoundingClientRect(), parentStyle = getComputedStyle(parentEl);
      const style = getComputedStyle(el), rect = el.getBoundingClientRect();
      const itemStyle = itemEl.style;
      itemStyle.position = "absolute";
      ["top", "left"].forEach((e) => {
        const borderWidth = parseInt(parentStyle[camelize(`border-${e}-width`)]);
        itemStyle[e] = Math.abs(rect[e] - parentRect[e]) - borderWidth + "px";
      });
      ["width", "height"].forEach((e) => itemStyle[e] = Math.ceil(rect[e]) + "px");
      itemStyle.borderRadius = style.borderRadius;
      itemStyle.zIndex = style.zIndex + 1;
    };
    resizeobserver.observer(parent.el, target.resizeCb);
    if (parentEl.timeoutTime)
      clearTimeout(parentEl.timeoutTimer);
    parentEl.timeoutTimer = setTimeout(() => {
      if (itemEl.hasAttribute("style")) {
        parentEl.appendChild(itemEl);
        el.__skeleton_item = itemEl;
        if (parentEl.timeoutTime)
          clearTimeout(parentEl.timeoutTimer);
      }
    }, 0);
  };
  const delItem = (target) => {
    const itemEl = target.el.__skeleton_item;
    target.el.classList.remove(`${itemPreCls}-target`);
    if (!itemEl)
      return;
    resizeobserver.unobserve(itemEl.parentElement, target.resizeCb);
    if (itemEl.parentNode)
      itemEl.parentNode.removeChild(itemEl);
    target.el.__skeleton_item = void 0;
  };
  let oldTargets = [];
  props.unwatch = watchPostEffect(() => {
    const {
      el,
      binding
    } = props;
    const targets = props.targets, loading = getLoading(binding.value);
    patchClass(el, getClass(binding), el.className.split(" ").filter((cls) => cls.includes(preCls)).join(" "));
    oldTargets.forEach((target) => {
      if (!loading)
        delItem(target);
    });
    targets.forEach((target) => loading ? createItem(props, target) : delItem(target));
    if (!loading)
      resizeobserver.unobserve(props.el);
    oldTargets = [...props.targets];
  });
  return props;
};
const skeletonList = [];
const name = "x-skeleton", preCls = `desty-${name}`, itemPreCls = `${preCls}_item`;
const DestySkeleton = {
  bind(el, binding) {
    skeletonList.push(setup({
      el,
      binding,
      targets: []
    }));
  },
  inserted: (el, binding) => {
    const props = skeletonList.find((e) => e.el === el);
    props.binding = binding;
  },
  update: (el, binding) => {
    const props = skeletonList.find((e) => e.el === el);
    props.binding = binding;
  },
  unbind(el) {
    const i = skeletonList.findIndex((e) => e.el === el);
    if (i < 0)
      return;
    skeletonList.splice(i, 1)[0].unwatch();
    resizeobserver.unobserve(el);
  },
  created(el, binding) {
    skeletonList.push(setup({
      el,
      binding,
      targets: []
    }));
  },
  mounted: (el, binding) => {
    const props = skeletonList.find((e) => e.el === el);
    props.binding = binding;
  },
  updated: (el, binding) => {
    const props = skeletonList.find((e) => e.el === el);
    props.binding = binding;
  },
  beforeUnmount(el) {
    const i = skeletonList.findIndex((e) => e.el === el);
    if (i < 0)
      return;
    skeletonList.splice(i, 1)[0].unwatch();
    resizeobserver.unobserve(el);
  }
};
const DestySkeletonItem = {
  inserted(el, binding) {
    const props = skeletonList.findLast((e) => e.el.contains(el));
    props === null || props === void 0 ? void 0 : props.targets.push({
      el,
      binding
    });
  },
  unbind(el) {
    const props = skeletonList.findLast((e) => e.el.contains(el));
    if (!props)
      return;
    const i = props.targets.findIndex((e) => e.el === el);
    if (i < 0)
      return;
    props.targets.splice(i, 1);
  },
  mounted(el, binding) {
    const props = skeletonList.findLast((e) => e.el.contains(el));
    props === null || props === void 0 ? void 0 : props.targets.push({
      el,
      binding
    });
  },
  beforeUnmount(el) {
    const props = skeletonList.findLast((e) => e.el.contains(el));
    if (!props)
      return;
    const i = props.targets.findIndex((e) => e.el === el);
    if (i < 0)
      return;
    props.targets.splice(i, 1);
  }
};
class DebugTool {
  constructor() {
    this.createScript = () => {
      if (this.consoleScript)
        return;
      this.consoleScript = document.createElement("script");
      this.consoleScript.src = "https://static.desty.app/desty-design/js/vconsole.min.js";
      this.consoleScript.async = true;
      document.body.appendChild(this.consoleScript);
      return new Promise((resolve, reject) => {
        if (this.consoleScript) {
          this.consoleScript.onload = function() {
            resolve(true);
          };
          this.consoleScript.onerror = function() {
            reject("this.consoleScript load error!");
          };
        } else {
          reject("this.consoleScript not exist!");
        }
      });
    };
    this.createVconsole = async (theme) => {
      try {
        await this.createScript();
        if (this.vConsole)
          return;
        this.vConsole = new window.VConsole({ theme });
      } catch (error) {
        console.log("createVconsole error", error);
      }
    };
    this.showDebugTool = async (params) => {
      try {
        const { enable, specRoutes, theme } = params || {};
        if (enable) {
          await this.createVconsole(theme);
          if (specRoutes) {
            const { pathname } = location;
            if (Array.isArray(specRoutes)) {
              if (specRoutes.includes(pathname)) {
                this.vConsole && this.vConsole.showSwitch();
              } else {
                this.vConsole && this.vConsole.hideSwitch();
              }
            } else {
              this.vConsole && this.vConsole.hideSwitch();
              throw new Error("param specRoutes must be array!");
            }
          }
        } else {
          this.consoleScript && document.body.removeChild(this.consoleScript);
        }
      } catch (error) {
        console.log("showDebugTool error", error);
      }
    };
    this.consoleScript = null;
    this.vConsole = null;
  }
}
const debugTool = new DebugTool();
const showDebugTool = debugTool.showDebugTool;
const ENV_DOMAIN = {
  chat: "https://platform-gateway-dev.desty.one",
  staging: "https://platform-gateway.desty.one",
  jmeter: "https://platform-gateway-staging.desty.one",
  production: "https://pulibic-gateway.desty.app"
};
function getBaseUrl(envTypeVar) {
  return ENV_DOMAIN[envTypeVar] || "https://platform-gateway.desty.one";
}
function _storageEnabled$1() {
  return navigator.cookieEnabled && typeof window.localStorage !== "undefined";
}
async function destyLogout(params) {
  if (!(params == null ? void 0 : params.env))
    throw new Error("env var must be exist\uFF01");
  if (!(params == null ? void 0 : params.token))
    throw new Error("token var must be exist\uFF01");
  if (!(params == null ? void 0 : params.app))
    throw new Error("app var must be exist\uFF01");
  const storageEnabled = _storageEnabled$1();
  try {
    if (storageEnabled) {
      await setDomianCookie(params.env, "");
    } else {
      console.error("cookies are disabled\uFF01");
    }
    const res = await axios({
      url: "/platform/user/sso/loginOut",
      method: "post",
      baseURL: getBaseUrl(params.env),
      data: {
        token: params.token,
        app: params.app
      }
    });
    const { code, message } = (res == null ? void 0 : res.data) || {};
    pushLog({
      key: "desty-design[destyLogout result]",
      sourceParams: JSON.stringify(params),
      resultCode: code,
      resultMessage: message
    });
    if (code === 200) {
      if (params.onSuccess)
        params.onSuccess();
    } else {
      if (params.onFail)
        params.onFail(message);
      console.log("destyLogout error", message);
    }
  } catch (error) {
    if (params.onFail)
      params.onFail(error);
    console.log("destyLogout error", error);
    pushLog({
      key: "desty-design[destyLogout catch error]",
      sourceParams: JSON.stringify(params),
      result: new Error(error).message
    });
  }
}
async function destyAlarm(params) {
  try {
    const { title, webhook, msgPayload, enable = false } = params;
    if (!enable)
      return false;
    if (!webhook)
      throw new Error("webhook not exist!");
    const res = await axios({
      url: "/api/lex/robot",
      method: "post",
      data: { title, webhook, msgPayload },
      baseURL: "https://www.desty.app"
    });
    const { code, msg } = (res == null ? void 0 : res.data) || {};
    if (code !== 0) {
      console.log("destyAlarm code", code, "destyAlarm msg", msg);
    }
  } catch (error) {
    console.log("destyAlarm error", error);
  }
}
const BASEURL_MAP = {
  chat: "https://platform-gateway-dev.desty.one",
  staging: "https://platform-gateway.desty.one",
  jmeter: "https://platform-gateway-staging.desty.one",
  production: "https://pulibic-gateway.desty.app"
};
function parseStr(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return str;
  }
}
function _storageEnabled() {
  return navigator.cookieEnabled && typeof window.localStorage !== "undefined";
}
function _loopCookieFn(name2, ca) {
  for (let i = 0; i < ca.length; i++) {
    const c = ca[i].trim();
    if (c.indexOf(name2) === 0) {
      return c.substring(name2.length, c.length);
    }
  }
  return "";
}
function _getBaseUrl(env) {
  return BASEURL_MAP[env] || "https://platform-gateway.desty.one";
}
const COOKIE_KEY = "token-maps";
class HandleCookie {
  constructor() {
  }
  handleGetSSOCookie() {
    var _a;
    const storageEnabled = _storageEnabled();
    if (storageEnabled) {
      const ca = (_a = document.cookie) == null ? void 0 : _a.split(";");
      const ssoVal = _loopCookieFn(`${COOKIE_KEY}=`, ca);
      const base64Atob = ssoVal ? window.atob(ssoVal) : ssoVal;
      return parseStr(base64Atob);
    } else {
      console.error("cookies are disabled\uFF01");
    }
  }
  async handleDispenseSSOCookie(params) {
    if (!(params == null ? void 0 : params.env))
      throw new Error("env var must be exist\uFF01");
    if (!(params == null ? void 0 : params.token))
      throw new Error("token var must be exist\uFF01");
    if (!(params == null ? void 0 : params.app))
      throw new Error("app var must be exist\uFF01");
    const storageEnabled = _storageEnabled();
    if (storageEnabled) {
      try {
        const res = await axios({
          url: "/platform/user/sso/login",
          method: "post",
          baseURL: _getBaseUrl(params.env),
          data: {
            token: params.token,
            app: params.app
          }
        });
        const { data: data2 = [], code, message } = (res == null ? void 0 : res.data) || {};
        pushLog({
          key: "desty-design[handleDispenseSSOCookie result]",
          sourceParams: JSON.stringify(params),
          resultCode: code,
          resultData: data2 && JSON.stringify(data2)
        });
        if (code === 200) {
          if (data2.length) {
            const appAndTokenObj = data2.reduce(
              (prev, curr) => {
                const obj = { ...prev, [curr.appName]: curr.token };
                return obj;
              },
              {}
            );
            const base64Str = window.btoa(JSON.stringify(appAndTokenObj));
            await setDomianCookie(params.env, base64Str);
          } else {
            console.log("/sso/login api get tokens array length is 0\uFF01");
          }
        } else if ([41006, 41007, 41008].includes(code)) {
          console.log(`handleDispenseCookie function code ${code}: ${message}`);
        } else {
          throw new Error(`handleDispenseCookie function error: ${message}`);
        }
      } catch (error) {
        pushLog({
          key: "desty-design[handleDispenseSSOCookie catch error]",
          sourceParams: JSON.stringify(params),
          result: new Error(error).message
        });
        throw new Error(`handleDispenseCookie function error: ${error}`);
      }
    } else {
      console.error("cookies are disabled\uFF01");
    }
  }
  handleClearSSOCookie() {
    const storageEnabled = _storageEnabled();
    if (storageEnabled) {
      document.cookie = `${COOKIE_KEY}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    } else {
      console.error("cookies are disabled\uFF01");
    }
  }
}
const destyHandleCookie = new HandleCookie();
var index$1 = "";
const components = [
  DestyHeader,
  DestyHeaderV2,
  DestyFooter,
  DestyDialog,
  DestyCountryDeny,
  DestyTranslate,
  DestyExchangeToken,
  DestyMarketAppsDialog,
  DestyMarketAppSelect,
  DestyMarketDiscovery
];
const directives = [
  {
    name: "desty-skeleton",
    directiveMeta: DestySkeleton
  },
  {
    name: "desty-skeleton-item",
    directiveMeta: DestySkeletonItem
  }
];
components.forEach((Comp) => {
  Comp.install = (app) => {
    app.component(Comp.name, Comp);
  };
});
directives.forEach((Dire) => {
  Dire.directiveMeta.install = (app) => {
    app.directive(Dire.name, Dire.directiveMeta);
  };
});
const install = function(app) {
  if (install.installed)
    return;
  if (typeof app.component === "function") {
    components.forEach((Comp) => app.component(Comp.name, Comp));
  }
  if (app.directive && typeof app.directive === "function") {
    directives.forEach(
      (Directive) => app.directive(Directive.name, Directive.directiveMeta)
    );
  }
};
if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}
var index = {
  install,
  DestyHeader,
  DestyHeaderV2,
  DestyFooter,
  DestyDialog,
  DestyTranslate,
  DestyCountryDeny,
  DestyExchangeToken,
  DestyMarketAppsDialog,
  DestySkeleton,
  DestySkeletonItem,
  showDebugTool,
  destyLogout,
  destyAlarm,
  destyHandleCookie,
  DestyMarketAppSelect,
  DestyMarketDiscovery
};
export { DestyCountryDeny, DestyDialog, DestyExchangeToken, DestyFooter, DestyHeader, DestyHeaderV2, DestyMarketAppSelect, DestyMarketAppsDialog, DestyMarketDiscovery, DestySkeleton, DestySkeletonItem, DestyTranslate, index as default, destyAlarm, destyHandleCookie, destyLogout, install, showDebugTool };
